<template>
    <v-container grid-list-xl fluid>
        <v-layout class="mx-1" wrap justify-center>
            <v-row no-gutters>
                <v-col cols="2" class="mr-1">
                    <v-card outlined class="ml-2">
                        <v-sheet class="rounded-lg">
                            <v-card flat class="rounded-lg mt-3">
                                <v-layout row class="align-center pt-4 justify-center">
                                    <div class="display-1">
                                        {{ tempoAtd }}
                                    </div>
                                </v-layout>
                            </v-card>
                            <v-divider class="my-2"></v-divider>
                            <v-list dense>
                                <v-list-item-group active-class="border" v-model="mItem" :color="items[mItem].color">
                                    <v-list-item v-for="(item, i) in items" :key="i" link
                                        :disabled="item.id == 7 && item.badge == 0 || item.disabled">
                                        <v-list-item-icon>
                                            <v-icon v-text="item.icon"></v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ item.text }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action v-show="item.badge">
                                            <v-avatar right size="20" class="amber lighten-2">
                                                {{ item.badge }}
                                            </v-avatar>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                            <v-divider />
                            <div class="pb-2">
                                <v-list dense>
                                    <v-list-item v-show="mFicha.status != 4"
                                        @click="mFicha.idProntuario == null ? verificarExamesComStatusAberto() : $emit('addVoltar')">
                                        <v-list-item-icon>
                                            <v-icon color="green">check_circle</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <strong> {{ mFicha.idProntuario == null ? 'Finalizar' : 'voltar' }}
                                                </strong>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-show="mFicha.status == 4" @click="$emit('addVoltar')">
                                        <v-list-item-icon>
                                            <v-icon color="orange">keyboard_return</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <strong>Voltar</strong>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-show="mFicha.idProntuario == null && mFicha.status != 4"
                                        @click="$emit('addListaDeEspera')">
                                        <v-list-item-icon>
                                            <v-icon color="orange darken-2">hourglass_top</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Espera
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </div>
                        </v-sheet>
                    </v-card>
                    <v-card outlined class="mx-auto mt-1 ml-2" height="25vh" style="overflow-y: auto;">
                        <v-list-item dense>
                            <v-list-item-content>
                                <v-list-item-title>Procedimentos</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider />
                        <v-list dense>

                            <v-list-item v-for="(item, i) in consultasPaciente" :key="i"
                                :disabled="item.cor === 'grey lighten-1'">

                                <v-list-item-content>
                                    <v-list-item-title v-text="item.nomeExame"></v-list-item-title>
                                </v-list-item-content>

                            </v-list-item>

                        </v-list>

                    </v-card>
                </v-col>

                <v-col v-show="selectedItem == 0" class="animated fadeIn">
                    <v-card outlined height="69vh" style="overflow-y: auto;">
                        <v-toolbar color="grey lighten-3" dense elevation="0">
                            <v-toolbar-title>
                                Resumo clínico
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-skeleton-loader v-if="loadResumo" type="article"></v-skeleton-loader>
                        <v-card-text v-if="resumoProntuarios != ''" v-html="resumoProntuarios">
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col v-if="selectedItem == 1" class="animated fadeIn">

                    <div>

                        <v-card flat>
                            <editor :isUltimoProntuario="listaPv2.length <= 0" v-if="!loadProntuario" :paciente="mFicha"
                                :conteudo="conteudoProntuario" :idProntuario="mFicha.idProntuario"
                                v-on:conteudo="getConteudoProntuario" />
                            <v-skeleton-loader v-else type="article, actions"></v-skeleton-loader>
                        </v-card>

                    </div>
                </v-col>

                <v-col v-if="selectedItem == 2" class="animated fadeIn">

                    <v-card outlined>
                        <div v-if="showPdfViewer">
                            <v-card flat>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn outlined @click="printPdf" color="primary" class="mr-2">
                                        <v-icon left>mdi-printer</v-icon>
                                        Imprimir
                                    </v-btn>
                                    <v-btn outlined @click="downloadPdf" color="secondary" class="mr-2">
                                        <v-icon left>mdi-download</v-icon>
                                        Download
                                    </v-btn>
                                    <v-btn outlined @click="closePdfViewer" color="error">
                                        <v-icon left>mdi-close</v-icon>
                                        Fechar
                                    </v-btn>
                                </v-card-actions>
                                <div class="text-center pdf-pagination">
                                    <v-pagination v-model="page" :length="numPages" :total-visible="7" circle
                                        color="primary"></v-pagination>
                                    <div class="page-counter">{{ page }} / {{ numPages }}</div>
                                </div>
                            </v-card>

                            <pdf ref="pdfViewer" :src="pdfSource" :page="page" @num-pages="numPages = $event"
                                @page-loaded="pageLoaded" @error="pdfError" style="border: 1px solid #ddd;" />
                        </div>
                        <v-sheet min-height="70vh" rounded="lg" v-if="!showPdfViewer">
                            <v-item-group v-if="!isAddReceita">
                                <v-container>
                                    <v-row>
                                        <v-col v-for="(mReceita, n) in receitas" :key="n" cols="12" md="4">
                                            <v-item v-slot="{ toggle }">
                                                <v-card outlined color="grey lighten-4">
                                                    <v-card flat color="grey lighten-4" height="150"
                                                        class="overflow-auto">
                                                        <v-card-title
                                                            :class="mReceita.descricao.length < 17 ? 'text-h6' : 'subtitle-2'"
                                                            :style="{ 'min-height': !mReceita.obs ? '80px' : 'auto' }">
                                                            <div
                                                                v-html="mReceita.descricao.slice(0, 200) + (mReceita.descricao.length > 200 ? '...' : '')">
                                                            </div>
                                                        </v-card-title>
                                                    </v-card>
                                                    <v-divider />
                                                    <v-card-actions v-if="!mReceita.remove">
                                                        <v-spacer />
                                                        <v-menu
                                                            :close-on-content-click="false"
                                                            offset-y
                                                            open-on-hover
                                                            dark
                                                            open-delay="0"
                                                            close-delay="80"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn :loading="loadDownload" icon color="primary" @click="imprimirReceita(mReceita)">
                                                                        <v-icon>visibility</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
                                                                <div style="font-size: 14px;">Acessar opções de impressão.</div>
                                                                <v-btn text small color="primary" @click="hintImprimirReceita = true">Saiba mais</v-btn>
                                                            </v-card>
                                                        </v-menu>

                                                        <v-menu
                                                            :close-on-content-click="false"
                                                            offset-y
                                                            open-on-hover
                                                            dark
                                                            open-delay="0"
                                                            close-delay="80"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn icon color="accent" @click="editReceita(n)">
                                                                        <v-icon>edit</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
                                                                <div style="font-size: 14px;">Alterar prescrição.</div>
                                                                <v-btn text small color="primary" @click="hintEditarPrescricao = true">Saiba mais</v-btn>
                                                            </v-card>
                                                        </v-menu>

                                                        <v-menu
                                                            :close-on-content-click="false"
                                                            offset-y
                                                            open-on-hover
                                                            dark
                                                            open-delay="0"
                                                            close-delay="80"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn icon @click="mReceita.remove = true">
                                                                        <v-icon>delete</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
                                                                <div style="font-size: 14px;">Remover prescrição.</div>
                                                                <v-btn text small color="primary" @click="hintExcluirReceita = true">Saiba mais</v-btn>
                                                            </v-card>
                                                        </v-menu>

                                                    </v-card-actions>
                                                    <!-- Área de confirmação de exclusão -->
                                                    <v-card-actions v-else class="px-4">
                                                        <v-alert color="red lighten-2" dense dorder="top" type="error"
                                                            class="mb-0 flex-grow-1">
                                                            Tem certeza que deseja excluir essa receita?
                                                        </v-alert>

                                                        <v-btn icon color="red" @click="excluirReceitaMedica(mReceita)">
                                                            <v-icon>check</v-icon>
                                                        </v-btn>
                                                        <v-btn icon @click="mReceita.remove = false">
                                                            <v-icon>close</v-icon>
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-item>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-item v-slot="{ toggle }">
                                                <v-card color="grey lighten-4" class="d-flex align-center"
                                                    max-height="250" height="250" width="250"
                                                    @click="toggle, isAddReceita = true">
                                                    <v-scroll-y-transition>
                                                        <div
                                                            class="text-h1 flex-grow-1 text-center compleA--text text--lighten-3">
                                                            <v-icon x-large :color="items[mItem].color">add</v-icon>
                                                        </div>
                                                    </v-scroll-y-transition>
                                                </v-card>
                                            </v-item>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-item-group>
                            <div class="pa-2">
                                <receita v-if="isAddReceita" v-on:addReceita="adcionarReceita"
                                    v-on:editarReceita="editarReceita" :ficha="mFicha"
                                    v-on:cancelar="isAddReceita = false, isEditarReceita = false, receitaEdit = {}, indexToEditReceita = ''"
                                    v-bind:isEditarReceita="isEditarReceita" v-bind:receitaEdit="receitaEdit">
                                </receita>
                                <div id="pdf-content" v-html="relatorioSelecionado"
                                    style="position: absolute; left: -9999px;">
                                </div>
                            </div>
                        </v-sheet>
                    </v-card>

                    <!--Hints Receituário-->
                    <v-dialog v-model="hintImprimirReceita" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                Acessar opções de impressão.
                            <v-spacer/>
                            <v-btn icon @click="hintImprimirReceita = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Abre a interface de gestão onde você pode <b>visualizar, gerar PDF, imprimir ou enviar online o documento</b>, conforme as opções disponíveis no sistema.
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="hintImprimirReceita" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                Acessar opções de impressão.
                            <v-spacer/>
                            <v-btn icon @click="hintImprimirReceita = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Abre a interface de gestão onde você pode <b>visualizar, gerar PDF, imprimir ou enviar online o documento</b>, conforme as opções disponíveis no sistema.
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="hintExcluirReceita" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                Remover prescrição.
                            <v-spacer/>
                            <v-btn icon @click="hintExcluirReceita = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Permite excluir <b>definitivamente a prescrição adicionada</b>, removendo-a do registro atual. O sistema solicitará confirmação antes de excluir para evitar erros.
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-col>
                <v-col v-show="selectedItem == 3" class="animated fadeIn">

                    <v-card outlined>
                        <v-sheet min-height="70vh" rounded="lg">

                            <v-item-group v-if="!isAddSolicitacao">
                                <v-container>
                                    <v-row>
                                        <v-col v-for="(solicitacao, n) in solicitacoesCards" :key="n" cols="4" md="4">
                                            <v-item v-slot="{ toggle }">
                                                <v-card>
                                                    <v-card flat class="overflow-y-auto" max-height="400" height="200">

                                                        <ol class="rounded-list ml-5 mr-1">
                                                            <li v-for="(item, index) in solicitacao.items" :key="index">
                                                                <a> {{
                                                                    item.nome
                                                                }}</a>
                                                            </li>
                                                        </ol>

                                                    </v-card>
                                                    <v-card-actions>
                                                        <v-chip class="ma-2" color="blue" label outlined
                                                            text-color="blue">
                                                            <v-icon left>
                                                                mdi-label
                                                            </v-icon>
                                                            Reg...
                                                        </v-chip>
                                                        <v-spacer />
                                                        <v-btn icon :color="solicitacao.isObs ? 'red' : 'orange'"
                                                            @click="solicitacao.isObs = !solicitacao.isObs; if (!solicitacao.isObs) solicitacao.observacao = ''">
                                                            <v-icon
                                                                v-text="solicitacao.isObs ? 'cancel' : 'note_add'"></v-icon>
                                                        </v-btn>
                                                        <v-btn icon color="primary"
                                                            @click="imprimirSolicitacao(solicitacao.items, solicitacao.observacao, 'CLINICA', solicitacao.data)">
                                                            <v-icon>print</v-icon>
                                                        </v-btn>
                                                        <v-btn icon color="accent" @click="editSolicitacao(n, false)">
                                                            <v-icon>edit</v-icon>
                                                        </v-btn>
                                                        <v-btn icon @click="solicitacoesCards.splice(n, 1)">
                                                            <v-icon>delete</v-icon>
                                                        </v-btn>
                                                    </v-card-actions>
                                                    <v-divider v-show="solicitacao.isObs"></v-divider>
                                                    <v-textarea v-show="solicitacao.isObs"
                                                        v-model="solicitacao.observacao" class="mx-2 mt-2"
                                                        background-color="amber lighten-5" color="orange-darken-5"
                                                        label="Observação" auto-grow />
                                                </v-card>
                                            </v-item>
                                        </v-col>
                                        <v-col v-for="(solicitacao, n) in solicitacoesLaboratorioCards" :key="n"
                                            cols="4" md="4">
                                            <v-item v-slot="{ toggle }">
                                                <v-card>
                                                    <v-card flat class="overflow-y-auto" max-height="400" height="200">

                                                        <ol class="rounded-list ml-5 mr-1">
                                                            <li v-for="(item, index) in solicitacao.items" :key="index">
                                                                <a> {{
                                                                    item.nome
                                                                }}</a>
                                                            </li>
                                                        </ol>

                                                    </v-card>
                                                    <v-card-actions>
                                                        <v-chip class="ma-2" color="primary" label outlined
                                                            text-color="primary">
                                                            <v-icon left>
                                                                mdi-label
                                                            </v-icon>
                                                            Lab...
                                                        </v-chip>
                                                        <v-spacer />
                                                        <v-menu
                                                            :close-on-content-click="false"
                                                            offset-y
                                                            open-on-hover
                                                            dark
                                                            open-delay="0"
                                                            close-delay="80"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn icon :color="solicitacao.isObs ? 'red' : 'orange'"
                                                                        @click="solicitacao.isObs = !solicitacao.isObs; if (!solicitacao.isObs) solicitacao.observacao = ''">
                                                                        <v-icon
                                                                            v-text="solicitacao.isObs ? 'cancel' : 'note_add'"></v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
                                                                <div style="font-size: 14px;">{{solicitacao.isObs ? 'Cancelar obervação': 'Incluir observações na solicitação.'}}</div>
                                                                <v-btn v-if="!solicitacao.isObs" text small color="primary" @click=" hintIncluirObservacoes = true">Saiba mais</v-btn>
                                                            </v-card>
                                                        </v-menu>

                                                        <v-menu
                                                            :close-on-content-click="false"
                                                            offset-y
                                                            open-on-hover
                                                            dark
                                                            open-delay="0"
                                                            close-delay="80"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn icon color="primary"
                                                                        @click="imprimirSolicitacao(solicitacao.items, solicitacao.observacao, 'LABORATORIO', solicitacao.data)">
                                                                        <v-icon>print</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
                                                                <div style="font-size: 14px;">Abrir opções de impressão da solicitação.</div>
                                                                <v-btn text small color="primary" @click="hintImprimirSolicitacao= true">Saiba mais</v-btn>
                                                            </v-card>
                                                        </v-menu>

                                                        <v-menu
                                                            :close-on-content-click="false"
                                                            offset-y
                                                            open-on-hover
                                                            dark
                                                            open-delay="0"
                                                            close-delay="80"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn icon color="accent" @click="editSolicitacao(n, true)">
                                                                        <v-icon>edit</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
                                                                <div style="font-size: 14px;">Editar solicitação.</div>
                                                                <v-btn text small color="primary" @click="hintEditarSolicitacao= true">Saiba mais</v-btn>
                                                            </v-card>
                                                        </v-menu>

                                                        <v-menu
                                                            :close-on-content-click="false"
                                                            offset-y
                                                            open-on-hover
                                                            dark
                                                            open-delay="0"
                                                            close-delay="80"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn icon @click="solicitacoesLaboratorioCards.splice(n, 1)">
                                                                        <v-icon>delete</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
                                                                <div style="font-size: 14px;">Excluir solicitação.</div>
                                                                <v-btn text small color="primary" @click="hintExcluirSolicitacao= true">Saiba mais</v-btn>
                                                            </v-card>
                                                        </v-menu>

                                                    </v-card-actions>
                                                    <v-divider v-show="solicitacao.isObs"></v-divider>
                                                    <v-textarea v-show="solicitacao.isObs"
                                                        v-model="solicitacao.observacao" class="mx-2 mt-2"
                                                        background-color="amber lighten-5" color="orange-darken-5"
                                                        label="Observação" auto-grow />
                                                </v-card>
                                            </v-item>
                                        </v-col>
                                        <v-col cols="4" md="4">
                                            <v-item v-slot="{ toggle }">
                                                <v-card color="grey lighten-4" class="d-flex align-center" height="250"
                                                    width="250" @click="toggle, isAddSolicitacao = true">
                                                    <v-scroll-y-transition>
                                                        <div
                                                            class="text-h1 flex-grow-1 text-center compleA--text text--lighten-3">
                                                            <v-icon x-large :color="items[mItem].color">add</v-icon>
                                                        </div>
                                                    </v-scroll-y-transition>
                                                </v-card>
                                            </v-item>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-item-group>
                            <div class="pa-2">
                                <solicitacao v-if="isAddSolicitacao" @cancelar="resetarFormularioEdicao"
                                    @solicitacoesLabCard="adicionarSolicitacaoLaboratorio"
                                    @solicitacoesCard="adcionarSolicitacao"
                                    @editarSolicitacaoLabCard="editarSolicitacaoLaboratorio"
                                    @editarSolicitacaoCard="editarSolicitacao" :mExames="examesEdit" :isLabAux="isLab"
                                    :paciente="mFicha" :isEditSolicitacao="isEditSolicitacao">
                                </solicitacao>

                                <!-- <receita v-if="isAddReceita" v-on:addReceita="adcionarReceita" v-on:cancelar="isAddReceita = false"></receita> -->
                            </div>
                        </v-sheet>
                    </v-card>

                    <!--Hints Solicitação-->
                    <v-dialog v-model="hintIncluirObservacoes" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                 Incluir observações na solicitação.
                            <v-spacer/>
                            <v-btn icon @click="hintIncluirObservacoes = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Permite adicionar uma <b>observação complementar na solicitação de exames</b>, que será impressa junto do pedido. Útil para orientações adicionais ou detalhes importantes ao laboratório ou setor responsável.
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="hintEditarSolicitacao" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                Alterar solicitação.
                            <v-spacer/>
                            <v-btn icon @click="hintEditarSolicitacao = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Abre uma solicitação de exame já lançada para <b>ajustar, alterar ou complementar informações antes da impressão ou envio</b>, mantendo o documento atualizado.
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="hintImprimirSolicitacao" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                Abrir opções de impressão da solicitação.
                            <v-spacer/>
                            <v-btn icon @click="hintImprimirSolicitacao = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Abre a interface para <b>visualizar, gerar PDF, imprimir ou enviar online a solicitação de exames</b>, garantindo controle sobre o envio e o documento final.
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="hintExcluirSolicitacao" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                Remover solicitação.
                            <v-spacer/>
                            <v-btn icon @click="hintExcluirSolicitacao = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Permite <b>excluir a solicitação de exames que já foi lançada</b>, removendo-a do sistema após confirmação, evitando erros ou duplicidades.
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-col>

                <v-col v-show="selectedItem == 4" class="animated fadeIn">

                    <v-card outlined>
                        <v-sheet min-height="70vh" rounded="lg">

                            <v-item-group v-if="!isAddLaudo">
                                <v-container>
                                    <v-row>
                                        <v-col v-for="(consulta, n) in consultasPaciente" :key="n" cols="4" md="4">
                                            <div v-if="(consulta.exigeLaudoClinico && consulta.cor !== 'grey lighten-1') && consulta.idMedico == user.id">
                                                <v-item>
                                                    <v-card outlined>
                                                        <v-card flat max-height="400" height="60">
                                                            <ol class="rounded-exame ml-5 mr-1">
                                                                <li>
                                                                    <a>{{ consulta.nomeExame }}</a>
                                                                </li>
                                                            </ol>
                                                        </v-card>
                                                        <v-card flat max-height="400" height="200"
                                                            class="overflow-y-auto">
                                                            <div class="mx-2" v-html="consulta.laudo" />
                                                        </v-card>
                                                        <v-card-actions>
                                                            <v-chip @click="consultaAux = consulta, isAddLaudo = true"
                                                                class="ma-2"
                                                                :color="consulta.laudo == '' ? items[mItem].color : 'orange'"
                                                                label outlined text-color="blue">
                                                                <v-icon
                                                                    :color="consulta.laudo == '' ? items[mItem].color : 'orange'"
                                                                    v-text="consulta.laudo == '' ? 'add' : 'edit'"></v-icon>
                                                            </v-chip>
                                                            <v-chip dark
                                                                :color="consulta.statusLaudo == 'A' ? 'orange' : consulta.statusLaudo == 'L' ? 'green' : 'grey'"
                                                                label v-show="consulta.statusLaudo != ''"
                                                                v-text="consulta.statusLaudo == 'A' ? 'ABERTO' : consulta.statusLaudo == 'L' ? 'LIBERADO' : 'PENDENTE'"></v-chip>
                                                            <v-spacer />
                                                                <v-menu
                                                                    :close-on-content-click="false"
                                                                    offset-y
                                                                    open-on-hover
                                                                    dark
                                                                    open-delay="0"
                                                                    close-delay="80"
                                                                >
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <div v-bind="attrs" v-on="on">
                                                                            <v-btn icon color="primary" @click="downlodLaudo(consulta.idexamesos)">
                                                                                <v-icon>print</v-icon>
                                                                            </v-btn>
                                                                        </div>
                                                                    </template>
                                                                    <v-card color="black" class="pa-2" min-width="130" style="opacity: 0.6; vertical-align: center;">
                                                                        <div style="font-size: 14px;">Imprimir laudo.</div>
                                                                    </v-card>
                                                                </v-menu>
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-item>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-item-group>
                            <div v-if="consultaAux != null">
                                <div v-if="consultaAux.exigeFichaAso">
                                    <fichaPaciente v-if="isAddLaudo && !consultaAux.psicoSocial"
                                        :idExamesOS="consultaAux.idexamesos" @voltar="voltarLaudo()" />
                                    <anamneseExame2 v-if="isAddLaudo && consultaAux.psicoSocial"
                                        :idExamesOS="consultaAux.idexamesos" @voltar="voltarLaudo()" />
                                </div>
                                <div class="pa-2" v-else>
                                    <laudoAtendimento v-if="isAddLaudo" @voltar="voltarLaudo()" :userAux="user"
                                        :paciente="mFicha" :consulta="consultaAux" @imprimirTexto="generateReport" />
                                </div>
                            </div>
                        </v-sheet>
                    </v-card>
                </v-col>

                <v-col v-if="selectedItem == 5" class="animated fadeIn">
                    <v-card outlined height="673" v-if="!isAddRelatorio">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title><strong>Relatório(s)</strong></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <div v-if="showPdfViewer">
                            <v-card flat>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn outlined @click="printPdf" color="primary" class="mr-2">
                                        <v-icon left>mdi-printer</v-icon>
                                        Imprimir
                                    </v-btn>
                                    <v-btn outlined @click="downloadPdf" color="secondary" class="mr-2">
                                        <v-icon left>mdi-download</v-icon>
                                        Download
                                    </v-btn>
                                    <v-btn outlined @click="closePdfViewer" color="error">
                                        <v-icon left>mdi-close</v-icon>
                                        Fechar
                                    </v-btn>
                                </v-card-actions>
                                <div class="text-center pdf-pagination">
                                    <v-pagination v-model="page" :length="numPages" :total-visible="7" circle
                                        color="primary"></v-pagination>
                                    <div class="page-counter">{{ page }} / {{ numPages }}</div>
                                </div>
                            </v-card>

                            <pdf ref="pdfViewer" :src="pdfSource" :page="page" @num-pages="numPages = $event"
                                @page-loaded="pageLoaded" @error="pdfError" style="border: 1px solid #ddd;" />
                        </div>
                        <v-item-group v-if="!showPdfViewer">
                            <v-container>
                                <v-row>

                                    <v-col v-for="(mRelatorio, n) in relatorios" :key="n" cols="12" md="4">
                                        <v-item v-slot="{ toggle }">

                                            <v-card outlined color="grey lighten-4">
                                                <v-card flat color="grey lighten-4" height="150" class="overflow-auto">
                                                    <v-card-title
                                                        :class="mRelatorio.descricao.length < 17 ? 'text-h6' : 'subtitle-2'"
                                                        :style="{ 'min-height': !mRelatorio.descricao ? '80px' : 'auto' }">
                                                        <div
                                                            v-html="mRelatorio.descricao.slice(0, 200) + (mRelatorio.descricao.length > 200 ? '...' : '')">
                                                        </div>
                                                    </v-card-title>
                                                </v-card>
                                                <v-divider />
                                                <v-card-actions v-if="!mRelatorio.confirmandoExclusao">
                                                    <v-spacer />
                                                    <v-menu
                                                            :close-on-content-click="false"
                                                            offset-y
                                                            open-on-hover
                                                            dark
                                                            open-delay="0"
                                                            close-delay="80"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn :loading="loadDownload" icon color="primary"
                                                                        @click="generateReportRelatorio(mRelatorio)">
                                                                        <v-icon>visibility</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
                                                                <div style="font-size: 14px;">Abrir opções de impressão do relatório.</div>
                                                                <v-btn text small color="primary" @click="hintImprimirRelatorio = true">Saiba mais</v-btn>
                                                            </v-card>
                                                    </v-menu>

                                                    <v-menu
                                                            :close-on-content-click="false"
                                                            offset-y
                                                            open-on-hover
                                                            dark
                                                            open-delay="0"
                                                            close-delay="80"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn icon color="accent"
                                                                        @click="relatorio = mRelatorio, isAddRelatorio = true">
                                                                        <v-icon>edit</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
                                                                <div style="font-size: 14px;">Editar relatório.</div>
                                                                <v-btn text small color="primary" @click="hintEditarRelatorio = true">Saiba mais</v-btn>
                                                            </v-card>
                                                    </v-menu>

                                                    <v-menu
                                                            :close-on-content-click="false"
                                                            offset-y
                                                            open-on-hover
                                                            dark
                                                            open-delay="0"
                                                            close-delay="80"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn icon @click="iniciarExclusao(mRelatorio)">
                                                                        <v-icon>delete</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
                                                                <div style="font-size: 14px;">Remover relatório.</div>
                                                                <v-btn text small color="primary" @click="hintExcluirRelatorio = true">Saiba mais</v-btn>
                                                            </v-card>
                                                    </v-menu>

                                                </v-card-actions>

                                                <!-- Área de confirmação de exclusão -->
                                                <v-card-actions v-else class="px-4">
                                                    <v-alert color="red lighten-2" dense dorder="top" type="error"
                                                        class="mb-0 flex-grow-1">
                                                        Tem certeza que deseja excluir este relatório?
                                                    </v-alert>

                                                    <v-btn icon color="red" @click="confirmarExclusao(mRelatorio)">
                                                        <v-icon>check</v-icon>
                                                    </v-btn>
                                                    <v-btn icon @click="cancelarExclusao(mRelatorio)">
                                                        <v-icon>close</v-icon>
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-item>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-item v-slot="{ toggle }">
                                            <v-card color="grey lighten-4" class="d-flex align-center" height="150"
                                                @click="relatorio = null, toggle, isAddRelatorio = true">
                                                <v-scroll-y-transition>
                                                    <div
                                                        class="text-h1 flex-grow-1 text-center compleA--text text--lighten-3">
                                                        <v-icon x-large :color="items[mItem].color">add</v-icon>
                                                    </div>
                                                </v-scroll-y-transition>
                                            </v-card>
                                        </v-item>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-item-group>
                    </v-card>
                    <editorRelatorio @voltar="voltarRelatorio()" :relatorio="relatorio" :paciente="mFicha" v-else />
                    <div id="pdf-content" v-html="relatorioSelecionado" style="position: absolute; left: -9999px;">
                    </div>

                    <!--Hints Relatório-->
                    <v-dialog v-model="hintEditarRelatorio" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                Alterar relatório.
                            <v-spacer/>
                            <v-btn icon @click="hintEditarRelatorio = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Abre um relatório médico já lançado para <b>ajustar, alterar ou complementar informações antes da impressão ou envio</b>, mantendo o documento atualizado.
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="hintImprimirRelatorio" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                Abrir opções de impressão do relatório.
                            <v-spacer/>
                            <v-btn icon @click="hintImprimirRelatorio = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Abre a interface para <b>visualizar, gerar PDF, imprimir ou enviar online o relatório médico</b>, garantindo controle sobre o envio e o documento final.
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="hintExcluirRelatorio" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                Remover relatório.
                            <v-spacer/>
                            <v-btn icon @click="hintExcluirRelatorio = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Permite <b>excluir o relatório que já foi lançado</b>, removendo-a do sistema após confirmação, evitando erros ou duplicidades.
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-col>
                <v-col :cols="prontuarioSelecionado != null ? 4 : laudoSelecionado != null ? 4 : 3" class="ml-1">
                    <assistentIa :system_prompt="resumoProntuarios"
                        v-if="!loadResumo && prontuarioSelecionado == null && laudoSelecionado == null"
                        @showChat="isShowChange" />
                    <div v-if="!isShow">
                        <!-- <div class="pr-2 mt-2">
                        <v-bottom-navigation v-model="itemBtn" :background-color="itemsBtn[itemBtn].color" dark shift
                            outlined>
                            <v-btn @click="clickBtn(item.id)" v-for="item in itemsBtn" :key="item.text">
                                <span>{{ item.text }}</span>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-btn>
                        </v-bottom-navigation>
                        </div> -->

                        <!-- Conteúdo de Laudos -->
                     <v-card outlined class="mx-auto mr-2 mt-1" max-width="500">
                        <!-- Seção de filtros -->
                        <div class="px-2 py-2">
                            <v-checkbox
                            class="ma-1"
                            v-model="isMeusAtendimentos"
                            color="blue"
                            hide-details
                            label="Meus atendimentos"
                            ></v-checkbox>

                            <v-chip-group v-model="filtros" column multiple>
                            <v-chip small filter outlined value="Laudo">Laudo</v-chip>
                            <v-chip small filter outlined value="Prontuário">Prontuário</v-chip>
                            <v-chip small filter outlined value="Solicitação">Solicitação</v-chip>
                            <v-chip small filter outlined value="Prescrição">Prescrição</v-chip>
                            </v-chip-group>
                             <!-- ✅ Novo campo de busca -->
                            <v-text-field
                            v-model="buscaConteudo"
                            append-icon="search"
                            label="Buscar no conteúdo"
                            outlined
                            dense
                            hide-details
                            class="mb-3"
                            />
                        </div>

                        <!-- Lista filtrada -->
                        <v-divider></v-divider>
                        <v-card-text class="scrollable" style="max-height: 470px; overflow-y: auto;">
                            <div v-for="(grupo, index) in gruposFiltrados" :key="index">
                            <v-divider class="my-1"></v-divider>
                            <v-icon color="blue" class="mr-2 pb-1">calendar_month</v-icon>
                            <strong>{{ grupo.data }}</strong>

                            <div v-for="(item, i) in grupo.itens" :key="i">
                                <div class="text-subtitle-2 font-weight-medium">
                                <strong :style="{ color: getTipoCor(item.tipo) }">{{ item.tipo }}</strong> -
                                <strong>{{ item.prestador || '' }}</strong>
                                </div>
                                <div class="text--caption my-2 ml-2" v-html="item.conteudo"></div>
                            </div>
                            </div>
                        </v-card-text>
                        </v-card>
                        <div v-if="isLaudo">
                            <!-- Detalhes do Laudo selecionado -->
                            <v-card :class="laudoSelecionado != null ? 'animated fadeInRight' : 'animated fadeOutRight'"
                                v-if="laudoSelecionado != null" outlined class="mx-auto mr-2" max-width="800"
                                height="80vh" style="overflow-y: auto;">
                                <v-toolbar elevation="0" dense>
                                    <v-icon :color="items[mItem].color">
                                        {{ items[mItem].icon }}
                                    </v-icon>
                                    <v-spacer />
                                    <v-btn color="red" icon @click="laudoSelecionado = null">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                </v-toolbar>

                                <v-list dense>
                                    <v-list-item dense three-line>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <strong>{{ listaL[laudoSelecionado].DataHora }}</strong>
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                <strong class="text-caption">{{ listaL[laudoSelecionado].Prestador
                                                    }}</strong>
                                            </v-list-item-subtitle>
                                            <v-list-item-subtitle class="text-caption">
                                                {{ listaL[laudoSelecionado].Exame }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider />
                                </v-list>

                                <v-card-text v-if="listaL[laudoSelecionado] && listaL[laudoSelecionado].descricaoLaudo"
                                    v-html="listaL[laudoSelecionado].descricaoLaudo"></v-card-text>
                            </v-card>

                            <!-- Lista de Laudos (quando nenhum está selecionado) -->

                            <!-- <template v-else>
                                <v-card outlined class="mx-auto mr-2" :loading="loadListaProntselectedItemuario">
                                    <strong>
                                        <v-checkbox :disabled="isMeu" class="ma-1" @change="listarProntuariosSimples"
                                            v-model="isMeusProntuarios" :color="items[mItem].color" hide-details
                                            label="Meus laudos"></v-checkbox>
                                    </strong>

                                    <v-divider class="mt-2" />

                                    <v-text-field :loading="loadListaProntuario" prepend-icon="search" label="Buscar"
                                        class="mx-2" v-model="searchLaudo"></v-text-field>

                                    <v-card flat height="34vh" style="overflow-y: auto;">
                                        <v-list>
                                            <v-list-item-group :color="items[mItem].color" v-model="laudoSelecionado">
                                                <template v-for="(item, i) in listaL">
                                                    <v-list-item :key="i" dense three-line>
                                                        <v-list-item-content>
                                                            <v-list-item-title>
                                                                <strong>{{ item.DataHora }}</strong>
                                                            </v-list-item-title>
                                                            <v-list-item-subtitle>
                                                                <strong class="text-caption">{{ item.Prestador
                                                                    }}</strong>
                                                            </v-list-item-subtitle>
                                                            <v-list-item-subtitle class="text-caption">
                                                                {{ item.Exame }}
                                                            </v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-divider :key="`divider-${i}`" />
                                                </template>
                                            </v-list-item-group>
                                        </v-list>

                                        <v-alert v-show="listaL.length <= 0" class="mx-1" dense border="top"
                                            color="red lighten-1" dark>
                                            Nenhum laudo encontrado!
                                        </v-alert>
                                    </v-card>
                                </v-card>
                            </template> -->
                        </div>

                        <!-- Conteúdo de Prontuários -->
                        <div v-else>
                            <!-- Detalhes do Prontuário selecionado -->
                            <v-card v-if="prontuarioSelecionado != null"
                                :class="prontuarioSelecionado != null ? 'animated fadeInRight' : 'animated fadeOutRight'"
                                outlined class="mx-auto mr-2" max-width="800" height="80vh" style="overflow-y: auto;">
                                <v-toolbar elevation="0" dense>
                                    <v-icon :color="items[mItem].color">
                                        {{ items[mItem].icon }}
                                    </v-icon>
                                    <v-spacer />
                                    <v-btn color="red" icon @click="prontuarioSelecionado = null">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                </v-toolbar>
                                <v-divider />
                                <v-list dense>
                                    <v-list-item dense three-line>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <strong>{{ listaPv2[prontuarioSelecionado].DataHora }}</strong>
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                <strong class="text-caption">{{
                                                    listaPv2[prontuarioSelecionado].Prestador
                                                    }}</strong>
                                            </v-list-item-subtitle>
                                            <v-list-item-subtitle class="text-caption">
                                                {{ listaPv2[prontuarioSelecionado].Exame }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider />
                                </v-list>

                                <v-card-text
                                    v-if="prontuarios[0] && prontuarios[0].prontuario && prontuarios[0].prontuario.descricao"
                                    v-html="prontuarios[0].prontuario.descricao"></v-card-text>
                            </v-card>

                            <!-- Lista de Prontuários -->
                            <!-- <v-card outlined class="mx-auto mt-1 mr-2" :loading="loadListaProntuario">
                                <strong>
                                    <v-checkbox class="ma-1" @change="listarLaudosSimples" v-model="isMeusProntuarios"
                                        color="amber accent-4" hide-details label="Meus prontuários"></v-checkbox>
                                </strong>

                                <v-divider class="mt-2" />

                                <v-text-field :loading="loadListaProntuario" prepend-icon="search" label="Buscar"
                                    class="mx-2" v-model="searchLaudo"></v-text-field>

                                <v-card :disabled="selectedItem != 1" flat height="34vh" style="overflow-y: auto;">
                                    <v-list>
                                        <v-list-item-group color="primary" v-model="prontuarioSelecionado">
                                            <template v-for="(item, i) in listaPv2">
                                                <v-list-item :key="i" dense three-line>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            <strong>{{ item.DataHora }}</strong>
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            <strong class="text-caption">{{ item.Prestador }}</strong>
                                                        </v-list-item-subtitle>
                                                        <v-list-item-subtitle class="text-caption">
                                                            {{ item.Exame }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-divider :key="`divider-${i}`" />
                                            </template>
                                        </v-list-item-group>
                                    </v-list>

                                    <v-alert v-show="listaPv2.length <= 0" class="mx-1" dense border="top"
                                        color="red lighten-1" dark>
                                        Nenhum prontuário encontrado!
                                    </v-alert>
                                </v-card>
                            </v-card> -->
                        </div>
                    </div>
                </v-col>
            </v-row>
                <v-dialog v-model="dialogAlerta" max-width="500">
                    <v-card>
                    <v-card-title class="headline error white--text">
                        <v-icon left color="white">mdi-alert</v-icon>
                        Atenção
                    </v-card-title>

                    <v-card-text class="pt-4 text-body-1">
                        {{ mensagemAlerta }}
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialogAlerta = false">
                        Entendi
                        </v-btn>
                    </v-card-actions>
                    </v-card>
                </v-dialog>

            <v-dialog v-model="dialog" persistent max-width="400">
                <v-card>
                    <v-card-title class="text-h5">
                        Exame complementar
                    </v-card-title>
                    <v-card-text>
                        Não há exame complementar solicitado. Deseja encerrar o atendimento? Ao encerrar, não será
                        possível imprimir
                        itens deste atendimento.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="dialog = false, $emit('encerrarAtd')">
                            sim
                        </v-btn>
                        <v-btn color="green darken-1" text @click="dialog = false">
                            não
                        </v-btn>

                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="erroProntuarioVazio" persistent max-width="290">
                <v-card>
                    <v-card-title class="text-h5">
                        Prontuário
                        <v-icon class="ml-2" color="red">error</v-icon>
                    </v-card-title>

                    <v-card-text>É necessário ter um prontuario cadastrado neste atendimento!</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="erroProntuarioVazio = false">
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogLaudo" persistent max-width="400">
                <v-card>
                    <v-card-title class="text-h5">
                        Atenção
                        <v-icon class="ml-2" color="orange">warning</v-icon>
                    </v-card-title>

                    <v-card-text>
                        Existem exames em aberto que exigem um laudo clínico.
                        Certifique-se de preenchê-los antes de continuar.
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogLaudo = false">Voltar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogProntuario" persistent max-width="400">
                <v-card>
                    <v-card-title class="text-h5">
                        Atenção
                        <v-icon class="ml-2" color="orange">warning</v-icon>
                    </v-card-title>

                    <v-card-text>
                        Alguns exames requerem o preenchimento do prontuário. Certifique-se de atualizá-lo antes de
                        prosseguir.
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogProntuario = false">Voltar</v-btn>
                        <!-- <v-btn color="blue darken-1" text @click="verificarExamesComStatusAberto()">
                                Continuar
                            </v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="desejaEncerrar" persistent max-width="400">
                <v-card>
                    <v-card-title class="text-h5">
                        Encerrar atendimento
                        <v-icon class="ml-2" color="orange">info</v-icon>
                    </v-card-title>

                    <v-card-text>
                        <b> Confirme para encerrar o atendimento! </b>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- Chama a função para encerrar atendimento e gerar o voucher -->
                        <v-btn color="green darken-1" text @click="confirmarEncerramento">
                            Sim
                        </v-btn>
                        <v-btn color="green darken-1" text @click="desejaEncerrar = false">
                            Não
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <br />
    </v-container>
</template>

<script>
import medicoService from '../../services/medico.service'
import editor from '../editorDeTexto/editor.vue'
import editorRelatorio from '../editorDeTexto/editorRelatorio.vue'
import laudo from '../editorDeTexto/laudo'
import laudoAtendimento from '../editorDeTexto/laudoAtendimento'
import receita from './receita.vue'
import solicitacao from './solicitacao.vue'
import VueHtml2pdf from 'vue-html2pdf'
import html2pdf from 'html2pdf.js'
import historico from './historico.vue'
import solicitacaoLaboratorio from './solicitacaoLaboratorio.vue'
import posAtendimentoService from '../../services/posAtendimento.service'
import anamnese from './anamnese.vue'
import html2canvas from 'html2canvas'
import LoginLayout from '../../views/LoginLayout.vue'
import socketService from '../../services/socket.service'
import fichaPaciente from './fichaPaciente.vue'
import anamneseExame2 from './anamneseExame2.vue'
import assistentIa from './assistentIa.vue'
import pdf from 'vue-pdf'

import { EventBus } from '../../main'

import {
  getToken
} from '../../store/auth'
import {
  mask
} from 'vue-the-mask'
// eslint-disable-next-line
/* eslint-disable */

export default {
    directives: {
        mask
    },
    name: 'prontuario',
    props: {
        tempoAtd: {
            type: String,
            default: '00:00:00'
        },
        mFicha: {
            type: Object
        },
        consultasPaciente: {
            type: Array
        }
    },
    components: {
        editor,
        laudo,
        laudoAtendimento,
        VueHtml2pdf,
        editorRelatorio,
        receita,
        solicitacao,
        historico,
        LoginLayout,
        solicitacaoLaboratorio,
        anamnese,
        fichaPaciente,
        anamneseExame2,
        pdf,
        assistentIa
    },
    data() {
        return {
            dialog: false,
            isShow: false,
            selectedItem: 0,
            itemBtn: 0,
            buscaConteudo: '',
            dialogAlerta: false,
            mensagemAlerta: '',
            isMeusAtendimentos: true,
            mItem: 0,
            isMedicamentos: false,
            isExames: false,
            colorItem: 0,
            isAddLaudo: false,
            isLaudo: false,
            isMeusProntuarios: true,
            dataSaida: '-',
            dialogLaudo: false,
            showPdfViewer: false,
            pdfSource: null,
            pdfBlob: null,
            loadReceita: false,
            page: 1,
            numPages: 0,
            hintMeusProntuarios: false,
            hintImprimirReceita: false,
            hintEditarPrescricao: false,
            hintExcluirReceita: false,
            hintIncluirObservacoes: false,
            hintEditarSolicitacao: false,
            hintImprimirSolicitacao: false,
            hintExcluirSolicitacao: false,
            hintImprimirLaudo: false,
            hintImprimirRelatorio: false,
            hintEditarRelatorio: false,
            hintExcluirRelatorio: false,
            loadProntuario: false,
            searchProntuariov2: '',
            searchLaudo: '',
            relatorioSelecionado: null,
            isMedico: false,
            listaProntuariosv2: [],
            listaLaudosV2: [],
            exigeAludo: 0,
            exigeProntuario: false,
            exigeFichaAso: false,
            listaPv2: [],
            listaL: [],
            dialogProntuario: false,
            prontuarioSelecionado: null,
            laudoSelecionado: null,
            isEdtProntuario: false,
            isProntuario: false,
            socket: {},
            loadRelatorio: false,
            relatorios: [],
            isAddRelatorio: false,
            relatorio: null,
            loadLaudo: false,
            loadDownload: false,
            isLaudo: false,
            ficha: this.mFicha,
            isLab: false,
            isImprime: false,
            resumoProntuarios: '',
            loadResumo: false,
            loadListaProntuario: false,
            isEdtReceita: false,
            isAddLaudo: false,
            date: new Date(),
            base64Image: '',
            menu1: false,
            menu2: false,
            consultaAux: null,
            solicitacoes: [],
            conteudoProntuario: '',
            filtros: ['Laudo', 'Prontuário', 'Solicitação', 'Prescrição'],
            dadosProntuario: [{
                idAtendimento: '',
                conteudoLaudo: '',
                conteudoProntuario: ''
            }],
            conteudoLaudo: '',
            conteudoProntuario: '',
            receitas: [],
            contentReceita: '',
            especialidades: [],
            especialidade: '-',
            isMeu: false,
            user: null,
            isAddReceita: false,
            laudo: '',
            listaConsultas: [],
            contentLaudo: '',
            dialogResumo: false,
            mSolicitacao: [],
            isAddSolicitacao: false,
            isEditSolicitacao: false,
            examesEdit: [],
            indexToEdit: '',
            solicitacoesCards: [],

            examesLabEdit: [],
            isAddSolicitacaoLaboratorio: false,
            isEditSolicitacaoLaboratorio: false,
            indexToEditLab: '',
            solicitacoesLaboratorioCards: [],

            isEditarReceita: false,
            indexToEditReceita: '',
            receitaEdit: {},
            //solicitacoes: [],
            erroProntuarioVazio: false,
            desejaEncerrar: false,
            tags: [{
                text: 'Diabetico',
                nome: 'diabetico',
                icon: 'clear',
                color: 'grey lighten-2'
            },
            {
                text: 'Colesterol alto',
                nome: 'colesterolAlto',
                icon: 'clear',
                color: 'grey lighten-2'
            },
            {
                text: 'Triglicerides alto',
                nome: 'trigliceridesAlto',
                icon: 'clear',
                color: 'grey lighten-2'
            },
            {
                text: 'Hipertenso',
                nome: 'hipertenso',
                icon: 'clear',
                color: 'grey lighten-2'
            },
            {
                text: 'Avaliacao renal',
                nome: 'avaliacaoRenal',
                icon: 'clear',
                color: 'grey lighten-2'
            },
            {
                text: 'Avaliacao tireoide',
                nome: 'avaliacaoTireoide',
                icon: 'clear',
                color: 'grey lighten-2'
            },
            {
                text: 'Etilismo',
                nome: 'etilismo',
                icon: 'clear',
                color: 'grey lighten-2'
            },
            {
                text: 'Tabagismo',
                nome: 'tabagismo',
                icon: 'clear',
                color: 'grey lighten-2'
            },
            {
                text: 'Usa óculus',
                nome: 'usaOculus',
                icon: 'clear',
                color: 'grey lighten-2'
            },
            {
                text: 'Uso medicamento',
                nome: 'usoMedicamento',
                icon: 'clear',
                color: 'grey lighten-2'
            },
            {
                text: 'Alergia',
                nome: 'alergia',
                icon: 'clear',
                color: 'grey lighten-2'
            },
            {
                text: 'Antecedentes familiares',
                nome: 'antecedentesFamiliares',
                icon: 'clear',
                color: 'grey lighten-2'
            },
            {
                text: 'Antecedentes patológicos',
                nome: 'antecedentesPatologicos',
                icon: 'clear',
                color: 'grey lighten-2'
            }
            ],
            items: [
                {
                    "text": "Resumo Clínico",
                    "icon": "book",
                    "id": 1,
                    "badge": 0,
                    "disabled": false,
                    "color": "#00BCD4"
                },
                {
                    "text": "Prontuário",
                    "icon": "description",
                    "id": 2,
                    "badge": 0,
                    "disabled": false,
                    "color": "#1E88E5"
                },
                {
                    "text": "Receituário",
                    "icon": "assignment_turned_in",
                    "id": 4,
                    "badge": 0,
                    "disabled": false,
                    "color": "#FFA07A"  /* Salmão forte */
                },
                {
                    "text": "Solicitação",
                    "icon": "pending_actions",
                    "id": 6,
                    "badge": this.exigeAludo,
                    "disabled": false,
                    "color": "#7B68EE"  /* Azul ardósia médio */
                },
                {
                    "text": "Laudo",
                    "icon": "post_add",
                    "badge": 0,
                    "id": 7,
                    "disabled": false,
                    "color": "#32CD32"  /* Verde lima */
                },
                {
                    "text": "Relatório",
                    "icon": "note",
                    "id": 8,
                    "badge": 0,
                    "disabled": false,
                    "color": "#9370DB"  /* Roxo médio */
                }
            ],
            itemsBtn: [
                {
                    "text": "Prontuário",
                    "icon": "description",
                    "id": 2,
                    "badge": 0,
                    "disabled": false,
                    "color": "#1E88E5"  /* Turquesa médio */
                },
                {
                    "text": "Laudo",
                    "icon": "post_add",
                    "badge": 0,
                    "id": 7,
                    "disabled": false,
                    "color": "#32CD32"  /* Verde lima */
                }
            ],
            links: [
                'Dashboard',
                'Messages',
                'Profile',
                'Updates',
            ],
            infoPaciente: '',
            isAddProntuario: true,
            qtdProntuarios: 0,
            currentProntuario: 0,
            prontuarios: [],
            loadProntuarios: false,
            dadosPaciente: {}
        }
    },

    methods: {
         getTipoCor(tipo) {
    switch (tipo) {
      case 'Prontuário': return '#1E88E5';  // Azul
      case 'Laudo': return '#32CD32';      // Verde
      case 'Solicitação': return '#7B68EE'; // Roxo
      case 'Prescrição': return '#FFA07A';  // Salmão
      default: return '#555';              // Cinza para tipos não definidos
    }
  },
        fechar() {
            console.log('Fechar modal ou card');
        },
        clickBtn(index) {
            switch (index) {
                case 2:
                    this.isLaudo = false
                    this.laudoSelecionado = null
                    break;

                default:
                    this.isLaudo = true
                    this.prontuarioSelecionado = null
                    break;
            }
        },
        retornarListaConsultas () {
  // remover o idMedico
            medicoService.medico.retornarListaConsultas(this.mFicha.idPaciente).then((r) => {
                if (r.status == 200) { 
                    this.listaConsultas = r.data.dados
                    
                }
            })
        },
         agruparPorData(lista) {
    const agrupado = {};

    lista.forEach(item => {
      // Extrai apenas a parte da data (sem hora)
      const data = item.data ? item.data.split(' ')[0] : 'sem_data';

      if (!agrupado[data]) {
        agrupado[data] = [];
      }
      agrupado[data].push(item);
    });

    // Ordena por data decrescente
    return Object.keys(agrupado)
      .sort((a, b) => new Date(b.split('/').reverse().join('/')) - new Date(a.split('/').reverse().join('/')))
      .map(data => ({ data, itens: agrupado[data] }));
  },
         formatarExames(examesString) {
            // Converte a string de exames em um array
            return examesString.split(", ");
        },
        isShowChange(val) {
            console.log('isShowChange: ', val)

            this.isShow = val
        },
        getContrastColor(hexColor) {
            // Converte cor HEX para RGB
            const r = parseInt(hexColor.substr(1, 2), 16);
            const g = parseInt(hexColor.substr(3, 2), 16);
            const b = parseInt(hexColor.substr(5, 2), 16);

            // Calcula luminosidade
            const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

            // Retorna preto ou branco dependendo do fundo
            return luminance > 0.5 ? '#000000' : '#FFFFFF';
        },
        excluirReceitaMedica(receita) {

            medicoService.medico.deleteReceitaById(receita.idReceitaMedica).then((r) => {
                if (r.status == 200) {
                    this.listarReceitasMedicas()
                    // this.$toast.success('Receita excluída com sucesso!')
                }
            })

        },
        listarReceitasMedicas() {
            this.loadReceita = true
            medicoService.medico.listarReceitaMedica(this.mFicha.idAtendimento, this.user.id).then((r) => {
                if (r.status == 200) {
                    this.receitas = r.data
                    this.loadReceita = false
                }
            }).finally(() => {
                this.loadReceita = false
            })
        },

        iniciarExclusao(relatorio) {
            this.$set(relatorio, 'confirmandoExclusao', true)
        },

        cancelarExclusao(relatorio) {
            this.$set(relatorio, 'confirmandoExclusao', false)
        },

        async confirmarExclusao(relatorio) {
            try {
                await medicoService.medico.removerRelatorio(relatorio.id).then(({ status, data }) => {
                    if (status == 200) {

                        this.buscarRelatoriosAtendimento()
                    }
                }).finally(() => {
                    this.$set(relatorio, 'confirmandoExclusao', false)
                })

            } catch (error) {
                console.error('Erro ao excluir relatório:', error)
            }
        },

        buscarRelatoriosAtendimento() {
            this.loadRelatorio = true
            medicoService.medico.buscarRelatoriosAtendimento(this.mFicha.idAtendimento).then(({ status, data }) => {
                if (status == 200) {
                    this.relatorios = data
                }
            }).finally(() => {
                this.loadRelatorio = false
            })
        },
        buscarProntuarioPorIdExamesOS() {
            this.loadProntuario = true

            medicoService.medico.buscarProntuarioPorIdExamesOS(this.mFicha.idExamesos)
                .then(({ status, data }) => {
                    if (status == 200) {
                        this.conteudoProntuario = data.registro
                        this.mFicha.idProntuario = data.idProntuario
                    }
                })
                .finally(() => { this.loadProntuario = false })
        },
        voltarLaudo() {
            this.isAddLaudo = false
            this.consultarInfoExames(this.consultasPaciente)
        },
        voltarRelatorio() {
            this.isAddRelatorio = false
            this.relatorio = null
            this.buscarRelatoriosAtendimento()
        },
        buscarLaudoClinicoPorIdExamesOS(idExamesOs) {
            // this.loadLaudo = true

            medicoService.medico.buscarLaudoClinicoPorIdExamesOS(idExamesOs).then(r => {
                if (r.status === 200) {
                    this.contentLaudo = r.data.descricaoLaudo
                }
            }).finally(() => {
                // this.loadLaudo = false
                return this.contentLaudo
            })
        },
        copiarProntuario() {
            this.conteudoProntuario = this.prontuarios[0].prontuario.descricao
            this.isAddProntuario = true
        },
        chamarSocket() {
            /*this.socket.on("resumoProntuario", (mensagem) => {
                var resumo = JSON.parse(JSON.stringify(mensagem));
                if (this.mFicha.idOrdemServico == resumo.os)
                    this.ajustarResumo(resumo);
            })*/
        },
        ajustarResumo(resumo) {
            if (this.ficha.idConsulta == resumo.idConsulta) { this.resumoProntuarios = resumo.descricao.substring(8) }
            if (resumo.tipo == 'RESUMO' && this.selectedItem == 1) {
                this.dialogResumo = true
            }
        },
        retornarInformacoesPacienteOs() {
            // EventBus.$emit('paciente-selecionado', this.dadosPaciente)
            medicoService.medico.retornarInformacoesPacienteOs(this.mFicha.idOrdemServico).then(r => {
                if (r.status == 200) {
                    this.dadosPaciente = r.data
                    this.dadosPaciente.nome = this.mFicha.nomePaciente
                    EventBus.$emit('paciente-selecionado', this.dadosPaciente)
                }
            })
        },

        async convertToBase64() {
            try {
                const div = this.$refs.myDiv;
                const canvas = await html2canvas(div, {
                    useCORS: true, // Set this to true if you're capturing content from other domains
                    backgroundColor: null, // Use the default background color
                    scale: 1, // Increase the scale for higher quality
                    dpi: 300, // Set the DPI to improve print quality
                    letterRendering: true // Use higher quality text rendering
                });
                const base64Image = canvas.toDataURL();
                this.base64Image = base64Image;
            } catch (error) {
                console.error(error);
            }
        },
        generateReportHTML() {
            this.$refs.html2Pdf.generatePdf()
            setTimeout(() => {
                this.isImprime = false
            }, 2000)

        },
        calcularIdade(dataNascimento) {
            let hoje = new Date();
            let nascimento = new Date(dataNascimento);
            let idade = hoje.getFullYear() - nascimento.getFullYear();
            let m = hoje.getMonth() - nascimento.getMonth();
            if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
                idade--;
            }

            // Verifica se o paciente faz aniversário no mês atual
            let fazAniversarioNoMesAtual = hoje.getMonth() === nascimento.getMonth();

            // Pega o dia de aniversário
            let diaAniversario = nascimento.getDate();

            // Pegar o mes de aniversário
            let mesAniversario = nascimento.getMonth();

            return {
                idade,
                fazAniversarioNoMesAtual,
                diaAniversario,
                mesAniversario
            };
        },
        formatTextForJasperReports(text) {
            // Mapeia tags HTML para tags JasperReport
            const tagMapping = {
                'h1': 'title',
                'h2': 'subtitle',
                'p': 'textField',
                'a': 'staticText',
                'b': 'style isBold="true"',
                'i': 'style isItalic="true"',
                'u': 'style isUnderline="true"',
                'br': 'break',
                'strong': 'style isBold="true"',
                'em': 'style isItalic="true"',
                // adicione mais mapeamentos conforme necessário
            };

            // Substitui tags HTML com tags JasperReport
            let jasperOutput = text;
            for (const tag in tagMapping) {
                const jasperTag = tagMapping[tag];
                const regexOpenTag = new RegExp(`<${tag}[^>]*>`, 'g');
                const regexCloseTag = new RegExp(`</${tag}>`, 'g');
                jasperOutput = jasperOutput.replace(regexOpenTag, `<${jasperTag}>`);
                jasperOutput = jasperOutput.replace(regexCloseTag, `</${jasperTag}>`);
            }

            // Envolva o texto formatado em CDATA para preservar a formatação no JasperReports
            // jasperOutput = '<textFieldExpression><![CDATA[' + jasperOutput + ']]></textFieldExpression>';

            return jasperOutput;
        },
        removeHtmlTags(str) {
            if ((str === null) || (str === ''))
                return false;
            else
                str = str.toString();
            return str.replace(/<[^>]*>/g, '');
        },
        downlodLaudo(idExamesOS) {
            // console.log('------');
            medicoService.medico.downloadLaudo(idExamesOS).then(r => {
                if (r.status == 200) {
                    const file = new Blob(
                        [r.data], {
                        type: 'application/pdf'
                    })
                    // Build a URL from the file
                    const fileURL = URL.createObjectURL(file)
                    // Open the URL on new Window
                    window.open(fileURL)
                }
            })
        },
        async generateReportLaudo(data) {

            let cabecalhoImg, rodapeImg;

            switch (this.user.idEmpresa) {
                case 4:
                    cabecalhoImg = "cabe_cmr_exame.png";
                    rodapeImg = "rodape_cmr.png";
                    break;
                case 1:
                    cabecalhoImg = "cabe_vit_exame.png";
                    rodapeImg = "rodape_vit.png";
                    break;
                case 11:
                    cabecalhoImg = "cabe_cmr_receita.png";
                    rodapeImg = "rodape_cmr.png";
                    break;
                case 7:
                    cabecalhoImg = "cabe_cmr_receita.png";
                    rodapeImg = "rodape_cmr.png";
                    break;
                default:
                    cabecalhoImg = "cabe_cmr_receita.png";
                    rodapeImg = "rodape_cmr.png";
                    break;
            }
            // console.log(data);
            this.loadLaudo = true
            await this.convertToBase64()
            var receituario = {
                paciente: this.mFicha.nomePaciente,
                solicitante: `Dr(a). ${this.user.nome}`,
                os: this.mFicha.idOrdemServico,
                atendimento: this.base64Image,
                medicamentos: data,
                crm: `${this.user.siglaConselho}/${this.user.ufConselho} - ${this.user.crm}`,
                descricao: "",
                tipo: "laudo",
                cabecalhoImg: cabecalhoImg,
                rodapeImg: rodapeImg
            }
            medicoService.medico.downloadRelatorioLaudo(receituario).then(r => {
                const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
                window.open(url, '_blank')
            }).finally(() => {
                this.loadLaudo = false
            })
        },
        formatHTMLForJasper(text) {
            if (!text) return '';

            // 1. Converte tags não suportadas em quebras de linha
            let result = text
                .replace(/<h1[^>]*>(.*?)<\/h1>/gi, '$1\n\n')  // <h1> vira texto + 2 quebras
                .replace(/<p[^>]*>/gi, '\n')                  // <p> vira quebra
                .replace(/<\/p>/gi, '\n')                     // </p> vira quebra
                .replace(/<div[^>]*>/gi, '\n')                // <div> vira quebra
                .replace(/<\/div>/gi, '\n');                  // </div> vira quebra

            // 2. Processa listas (opcional, se necessário)
            result = result
                .replace(/<ul[^>]*>/gi, '\n')
                .replace(/<ol[^>]*>/gi, '\n')
                .replace(/<\/[ou]l>/gi, '\n')
                .replace(/<li[^>]*>/gi, '\n• ')
                .replace(/<\/li>/gi, '');

            // 3. Remove tags não suportadas (exceto as permitidas pelo Jasper)
            const allowedTags = ['b', 'strong', 'i', 'em', 'u', 'sub', 'sup', 'font', 'span'];
            const allowedAttributes = ['color', 'size', 'face', 'style'];

            // Usa DOMParser para manipulação segura
            const doc = new DOMParser().parseFromString(result, 'text/html');
            const elements = doc.body.querySelectorAll('*');

            elements.forEach(element => {
                const tagName = element.tagName.toLowerCase();

                // Remove tags não permitidas (mantém o conteúdo)
                if (!allowedTags.includes(tagName)) {
                    const parent = element.parentNode;
                    while (element.firstChild) {
                        parent.insertBefore(element.firstChild, element);
                    }
                    parent.removeChild(element);
                } else {
                    // Remove atributos não permitidos
                    Array.from(element.attributes).forEach(attr => {
                        if (!allowedAttributes.includes(attr.name.toLowerCase())) {
                            element.removeAttribute(attr.name);
                        }
                    });

                    // Limita 'style' apenas a 'color' (Jasper não aceita outros CSS)
                    if (element.hasAttribute('style')) {
                        const style = element.getAttribute('style');
                        const colorMatch = style.match(/color:\s*([^;]+)/);
                        if (colorMatch) {
                            element.setAttribute('style', `color: ${colorMatch[1]}`);
                        } else {
                            element.removeAttribute('style');
                        }
                    }
                }
            });

            // 4. Extrai o HTML processado (sem <body> ou <html>)
            result = doc.body.innerHTML;

            // 5. Decodifica entidades HTML (&nbsp;, &amp;, etc.)
            result = result.replace(/&nbsp;/g, ' ');

            // 6. Normaliza quebras de linha (opcional)
            result = result.replace(/\n{3,}/g, '\n\n');

            return result.trim();
        },
        generateReport(data) {
            // data.nome = this.removeHtmlTags(data.nome)
            const medicamentos = this.receitas

            let cabecalhoImg, rodapeImg;

            switch (this.user.idEmpresa) {
                case 4:
                    cabecalhoImg = "cabe_cmr_receita.png";
                    rodapeImg = "rodape_cmr.png";
                    break;
                case 1:
                    cabecalhoImg = "cabe_vit_receita.png";
                    rodapeImg = "rodape_vit.png";
                    break;
                case 7:
                    cabecalhoImg = "cabe_pp_receita.png";
                    rodapeImg = "rodape_pp.png";
                    break;
                default:
                    cabecalhoImg = "cabe_cmr_receita.png";
                    rodapeImg = "rodape_cmr.png";
                    break;
            }

            // Agora você pode usar cabecalhoImg e rodapeImg

            var receituario = {
                paciente: this.mFicha.nomePaciente,
                solicitante: `Dr(a). ${this.user.nome}`,
                os: this.mFicha.idOrdemServico,
                atendimento: this.mFicha.idAtendimento,
                medicamentos: medicamentos,
                descricao: "",
                dataConsulta: data.data,
                receita: this.formatHTMLForJasper(data.nome),
                crm: `${this.user.siglaConselho}/${this.user.ufConselho} - ${this.user.crm}`,
                tipo: "solicitacaoReceita",
                cabecalhoImg: cabecalhoImg,
                rodapeImg: rodapeImg
            }
            medicoService.medico.downloadRelatorioReceita(receituario).then(r => {
                const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
                window.open(url, '_blank')

            })
        },
        printPdf() {
            if (this.$refs.pdfViewer) {
                this.$refs.pdfViewer.print();
            }
        },

        downloadPdf() {
            if (!this.pdfBlob) return;

            const url = URL.createObjectURL(this.pdfBlob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'relatorio.pdf';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },

        closePdfViewer() {
            this.showPdfViewer = false;
            if (this.pdfSource) {
                URL.revokeObjectURL(this.pdfSource);
                this.pdfSource = null;
            }
            this.pdfBlob = null;
        },

        pageLoaded(currentPage) {
            this.page = currentPage;
        },

        pdfError(error) {
            console.error("Erro ao carregar PDF:", error);
        },

        async generateReportRelatorio(data) {
            try {
                this.relatorioSelecionado = data.descricao;
                this.loadDownload = true
                // 1. Pré-processamento - Ajustar layout para landscape
                const element = document.getElementById('pdf-content');
                const originalStyles = {
                    width: element.style.width,
                    height: element.style.height,
                    overflow: element.style.overflow,
                    padding: element.style.padding
                };

                // Define estilos temporários para o elemento
                element.style.width = '297mm'; // Largura do A4 landscape (297mm)
                element.style.height = 'auto';
                element.style.overflow = 'visible';
                element.style.padding = '15mm'; // Margem interna

                // 2. Configurações otimizadas para landscape
                const options = {
                    margin: [10, 10, 10, 10], // Margens reduzidas
                    filename: 'relatorio.pdf',
                    image: {
                        type: 'jpeg',
                        quality: 1
                    },
                    html2canvas: {
                        scale: 2, // Escala balanceada
                        windowWidth: 1123, // Largura em pixels para A4 landscape (297mm)
                        width: 1123, // Mesma largura que windowWidth
                        height: element.scrollHeight, // Altura automática
                        letterRendering: true,
                        useCORS: true,
                        logging: false,
                        backgroundColor: '#FFFFFF',
                        scrollX: 0, // Garante que não há scroll horizontal
                        scrollY: 0,
                        ignoreElements: (element) => {
                            return element.classList.contains('ignore-pdf');
                        },
                        onclone: (clonedDoc) => {
                            // Aplica estilos adicionais no clone
                            const clonedElement = clonedDoc.getElementById('pdf-content');
                            clonedElement.style.width = '297mm';
                            clonedElement.style.overflow = 'visible';

                            // Garante que tabelas e outros elementos se ajustem
                            clonedElement.querySelectorAll('table').forEach(table => {
                                table.style.width = '100%';
                                table.style.maxWidth = 'none';
                            });
                        }
                    },
                    jsPDF: {
                        unit: 'mm',
                        format: 'a4',
                        orientation: 'landscape', // Força orientação landscape
                        hotfixes: ['px_scaling'],
                        compress: false
                    },
                    pagebreak: {
                        mode: ['css', 'legacy'],
                        avoid: ['tr', 'td', 'th', '.no-break'] // Classes/elementos para evitar quebras
                    },
                    enableLinks: true
                };




                const pdfDataUrl = await html2pdf()
                    .from(element)
                    .set(options)
                    .output('datauristring');

                // 4. Geração da imagem de preview
                const canvas = await html2canvas(element, {
                    scale: 2,
                    windowWidth: 1123,
                    width: 1123,
                    height: element.scrollHeight,
                    useCORS: true,
                    letterRendering: true,
                    logging: false,
                    backgroundColor: '#FFFFFF'
                });

                const imageBase64 = canvas.toDataURL('image/jpeg', 1.0);
                const base64Pure = imageBase64.split(',')[1];

                // Configura cabeçalho/rodapé
                let cabecalhoImg, rodapeImg;
                switch (this.user.idEmpresa) {
                    case 4:
                        cabecalhoImg = "cabe_cmr_receita.png";
                        rodapeImg = "rodape_cmr.png";
                        break;
                    case 1:
                        cabecalhoImg = "cabe_vit_receita.png";
                        rodapeImg = "rodape_vit.png";
                        break;
                    case 7:
                        cabecalhoImg = "cabe_pp_receita.png";
                        rodapeImg = "rodape_pp.png";
                        break;
                    default:
                        cabecalhoImg = "cabe_cmr_receita.png";
                        rodapeImg = "rodape_cmr.png";
                }

                // Formata data
                const mData = new Date(data.dataCadastro);
                const dataFormatada = [
                    String(mData.getDate()).padStart(2, "0"),
                    String(mData.getMonth() + 1).padStart(2, "0"),
                    mData.getFullYear()
                ].join('/');

                // Objeto final (agora com Base64 real, não uma Promise)
                const receituario = {
                    paciente: this.mFicha.nomePaciente,
                    solicitante: `Dr(a). ${this.user.nome}`,
                    os: this.mFicha.idOrdemServico,
                    atendimento: this.mFicha.idAtendimento,
                    medicamentos: [],
                    descricao: "",
                    dataConsulta: dataFormatada,
                    receita: base64Pure, // String Base64 válida
                    crm: `${this.user.siglaConselho}/${this.user.ufConselho} - ${this.user.crm}`,
                    tipo: "solicitacaoRelatorio",
                    cabecalhoImg,
                    rodapeImg
                };

                // Envia para o backend
                const response = await medicoService.medico.downloadRelatorioReceita(receituario).finally(() => {
                    this.loadDownload = false;
                })

                this.pdfBlob = new Blob([response.data], { type: 'application/pdf' });

                // Cria URL do objeto para o vue-pdf
                this.pdfSource = URL.createObjectURL(this.pdfBlob);
                this.showPdfViewer = true;
                this.page = 1; // Reset para a primeira página
                // Abre o PDF gerado
                // const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                // window.open(url, '_blank');

            } catch (error) {
                console.error("Erro ao gerar relatório:", error);
            }
        },

        setSolicitacoes(data) {
            this.mSolicitacao = data
        },
        getConteudoProntuario(val) {
            //console.log('-------->', val)
            this.conteudoProntuario = val
        },
        getConteudoLaudo(val) {
            this.conteudoLaudo = val
        },
        async imprimirReceita(data) {

            try {
                this.relatorioSelecionado = data.descricao;
                this.loadDownload = true
                // 1. Pré-processamento - Ajustar layout para landscape
                const element = document.getElementById('pdf-content');
                const originalStyles = {
                    width: element.style.width,
                    height: element.style.height,
                    overflow: element.style.overflow,
                    padding: element.style.padding
                };

                // Define estilos temporários para o elemento
                element.style.width = '297mm'; // Largura do A4 landscape (297mm)
                element.style.height = 'auto';
                element.style.overflow = 'visible';
                element.style.padding = '15mm'; // Margem interna

                // 2. Configurações otimizadas para landscape
                const options = {
                    margin: [10, 10, 10, 10], // Margens reduzidas
                    filename: 'relatorio.pdf',
                    image: {
                        type: 'jpeg',
                        quality: 1
                    },
                    html2canvas: {
                        scale: 2, // Escala balanceada
                        windowWidth: 1123, // Largura em pixels para A4 landscape (297mm)
                        width: 1123, // Mesma largura que windowWidth
                        height: element.scrollHeight, // Altura automática
                        letterRendering: true,
                        useCORS: true,
                        logging: false,
                        backgroundColor: '#FFFFFF',
                        scrollX: 0, // Garante que não há scroll horizontal
                        scrollY: 0,
                        ignoreElements: (element) => {
                            return element.classList.contains('ignore-pdf');
                        },
                        onclone: (clonedDoc) => {
                            // Aplica estilos adicionais no clone
                            const clonedElement = clonedDoc.getElementById('pdf-content');
                            clonedElement.style.width = '297mm';
                            clonedElement.style.overflow = 'visible';

                            // Garante que tabelas e outros elementos se ajustem
                            clonedElement.querySelectorAll('table').forEach(table => {
                                table.style.width = '100%';
                                table.style.maxWidth = 'none';
                            });
                        }
                    },
                    jsPDF: {
                        unit: 'mm',
                        format: 'a4',
                        orientation: 'landscape', // Força orientação landscape
                        hotfixes: ['px_scaling'],
                        compress: false
                    },
                    pagebreak: {
                        mode: ['css', 'legacy'],
                        avoid: ['tr', 'td', 'th', '.no-break'] // Classes/elementos para evitar quebras
                    },
                    enableLinks: true
                };

                const pdfDataUrl = await html2pdf()
                    .from(element)
                    .set(options)
                    .output('datauristring');

                // 4. Geração da imagem de preview
                const canvas = await html2canvas(element, {
                    scale: 2,
                    windowWidth: 1123,
                    width: 1123,
                    height: element.scrollHeight,
                    useCORS: true,
                    letterRendering: true,
                    logging: false,
                    backgroundColor: '#FFFFFF'
                });

                const imageBase64 = canvas.toDataURL('image/jpeg', 1.0);
                const base64Pure = imageBase64.split(',')[1];

                const medicamentos = this.receitas

                let cabecalhoImg, rodapeImg;

                switch (this.user.idEmpresa) {
                    case 4:
                        cabecalhoImg = "cabe_cmr_receita.png";
                        rodapeImg = "rodape_cmr.png";
                        break;
                    case 1:
                        cabecalhoImg = "cabe_vit_receita.png";
                        rodapeImg = "rodape_vit.png";
                        break;
                    case 7:
                        cabecalhoImg = "cabe_pp_receita.png";
                        rodapeImg = "rodape_pp.png";
                        break;
                    default:
                        cabecalhoImg = "cabe_cmr_receita.png";
                        rodapeImg = "rodape_cmr.png";
                        break;
                }

                // Agora você pode usar cabecalhoImg e rodapeImg
                const date = new Date(data.dataCriacao);

                const dia = String(date.getDate()).padStart(2, "0");
                const mes = String(date.getMonth() + 1).padStart(2, "0");
                const ano = date.getFullYear();

                const dataFormatada = data.dataSelecionada != '' ? `${dia}/${mes}/${ano}` : '';

                var receituario = {
                    paciente: this.mFicha.nomePaciente,
                    solicitante: `Dr(a). ${this.user.nome}`,
                    os: this.mFicha.idOrdemServico,
                    atendimento: this.mFicha.idAtendimento,
                    medicamentos: medicamentos,
                    descricao: "",
                    dataConsulta: dataFormatada,
                    receita: base64Pure,
                    crm: `${this.user.siglaConselho}/${this.user.ufConselho} - ${this.user.crm}`,
                    tipo: "solicitacaoReceita",
                    cabecalhoImg: cabecalhoImg,
                    rodapeImg: rodapeImg
                }

                // Envia para o backend
                const response = await medicoService.medico.downloadRelatorioReceita(receituario).finally(() => {
                    this.loadDownload = false
                })

                this.pdfBlob = new Blob([response.data], { type: 'application/pdf' });

                // Cria URL do objeto para o vue-pdf
                this.pdfSource = URL.createObjectURL(this.pdfBlob);
                this.showPdfViewer = true;
                this.page = 1; // Reset para a primeira página
                // Abre o PDF gerado
                // const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                // window.open(url, '_blank');

            } catch (error) {
                console.error("Erro ao gerar receituário:", error);
            }
            //this.generateReport(this.receitas[index])
            //this.isImprime = true
        },
        imprimirSolicitacao(mSolicitacao, observacao, tipo, data) {
            const solicitacao = []
            const exames = []
            const solicitacoesCards = mSolicitacao
            console.log('------=', solicitacoesCards, '=-------')

            // Preenchendo a lista de solicitações
            // if (item.index == null) {
            for (let i = 0; i < solicitacoesCards.length; i++) {
                const e = solicitacoesCards[i];
                e.nome = e.apelido;
                solicitacao.push(e);
                exames.push({ id: e.idExame });
            }
            // this.gerarVoucher(tipo, exames, true, this.mFicha.idOrdemServico);
            // } 
            // else {
            //     const array = solicitacoesCards[item.index];
            //     for (let j = 0; j < array.length; j++) {
            //         const e = array[j];
            //         e.nome = e.apelido;
            //         solicitacao.push(e);
            //     }
            // }

            // Seleção de imagens de cabeçalho e rodapé com base no idEmpresa
            let cabecalhoImg, rodapeImg;

            switch (this.user.idEmpresa) {
                case 4:
                    cabecalhoImg = "cabe_cmr_exame.png";
                    rodapeImg = "rodape_cmr.png";
                    break;
                case 1:
                    cabecalhoImg = "cabe_vit_exame.png";
                    rodapeImg = "rodape_vit.png";
                    break;
                case 7:
                    cabecalhoImg = "cabe_pp_exame.png";
                    rodapeImg = "rodape_pp.png";
                    break;
                default:
                    cabecalhoImg = "cabe_cmr_exame.png";
                    rodapeImg = "rodape_cmr.png";
                    break;
            }

            // Criação do objeto receituário
            
            
            
                const receituario = {
                    paciente: this.mFicha.nomePaciente,
                    solicitante: `Dr(a). ${this.user.nome}`,
                    os: this.mFicha.idOrdemServico,
                    atendimento: this.mFicha.idAtendimento,
                    medicamentos: this.receitas ? this.receitas : [],
                    crm: `${this.user.siglaConselho}/${this.user.ufConselho} - ${this.user.crm}`,
                    exames: solicitacao,
                    receita: '',
                    dataConsulta: data,
                    descricao: observacao != undefined ? observacao : '',
                    tipo: 'solicitacaoExames',
                    cabecalhoImg: cabecalhoImg,
                    rodapeImg: rodapeImg
                };
                 console.log(receituario);

                // Download do relatório em PDF
                medicoService.medico.downloadRelatorioReceita(receituario).then(r => {
                    const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
                    window.open(url, '_blank');
                });
            
        },

        retornarResumoProntuario() {
            this.loadResumo = true
            medicoService.medico.resumomedico(this.ficha.idPaciente, this.user.id).then(r => {
                if (r.status == 200) {
                    this.resumoProntuarios = r.data.resumo
                    if (r.data.tipo == 'RESUMO') {
                        // this.dialogResumo = true
                    }
                }
            }).finally(() => {
                this.loadResumo = false
            })
        },
     

        setContent(data) {
            this.laudo = data
        },
        adcionarReceita(data) {
            this.isAddReceita = false
            //console.log('-------', data)
            // this.receitas.push(data)
            this.listarReceitasMedicas()
        },
        editReceita(index) {
            this.isEditarReceita = true
            this.isAddReceita = true
            this.receitaEdit = this.receitas[index]
            this.indexToEditReceita = index
            // console.log('Editando: ', this.indexToEditReceita)
        },
        editarReceita(data) {
            this.receitas[this.indexToEditReceita] = data
            this.receitaEdit = {}
            this.indexToEditReceita = ''
            this.isEditarReceita = false
            this.isAddReceita = false
        },
        adcionarSolicitacao(data) {
            this.isAddSolicitacao = false;

            if (data.isLaboratorio) {
                this.solicitacoesLaboratorioCards.push(data);
            } else {
                this.solicitacoesCards.push(data);
            }
        },

        adicionarSolicitacaoLaboratorio(data) {
            this.isAddSolicitacao = false;
            this.solicitacoesLaboratorioCards.push(data);
        },

        editarSolicitacao(data) {
            // Substituir o item existente no array regular pelo novo dado.
            this.solicitacoesCards[this.indexToEdit] = data;
            this.resetarFormularioEdicao();
        },

        editarSolicitacaoLaboratorio(data) {
            // Substituir o item existente no array de laboratório pelo novo dado.
            this.solicitacoesLaboratorioCards[this.indexToEditLab] = data;
            this.resetarFormularioEdicao();
        },

        editSolicitacao(index, isLab) {
            this.isLab = isLab;
            this.isAddSolicitacao = true;
            this.isEditSolicitacao = true;

            if (isLab) {
                // Preparar edição de laboratório.
                this.indexToEditLab = index;
                this.examesEdit = [...this.solicitacoesLaboratorioCards[index].items];
            } else {
                // Preparar edição regular.
                this.indexToEdit = index;
                this.examesEdit = [...this.solicitacoesCards[index].items];
            }
        },

        resetarFormularioEdicao() {
            this.isAddSolicitacao = false;
            this.isEditSolicitacao = false;
            this.examesEdit = [];
            this.indexToEdit = null;
            this.indexToEditLab = null;
        },

        carregarInfomacoesPaciente() {
            medicoService.medico.retornarInfoPacienteOs(this.mFicha.idOrdemServico).then(r => {
                if (r.status == 200) {
                    var info = r.data.infoPaciente
                    this.infoPaciente = info
                    //this.infoPaciente.descricaoAlergia = "Teste 44444444"
                    if (info.diabetico) {
                        var index = this.buscarTag('diabetico')
                        this.tags[index].icon = 'done'
                        this.tags[index].color = 'analogoD'
                    }
                    if (info.colesterolAlto) {
                        var index = this.buscarTag('colesterolAlto')
                        this.tags[index].icon = 'done'
                        this.tags[index].color = 'analogoD'
                    }
                    if (info.trigliceridesAlto) {
                        var index = this.buscarTag('trigliceridesAlto')
                        this.tags[index].icon = 'done'
                        this.tags[index].color = 'analogoD'
                    }
                    if (info.hipertenso) {
                        var index = this.buscarTag('hipertenso')
                        this.tags[index].icon = 'done'
                        this.tags[index].color = 'analogoD'
                    }
                    if (info.avaliacaoRenal) {
                        var index = this.buscarTag('avaliacaoRenal')
                        this.tags[index].icon = 'done'
                        this.tags[index].color = 'analogoD'
                    }
                    if (info.avaliacaoTireoide) {
                        var index = this.buscarTag('avaliacaoTireoide')
                        this.tags[index].icon = 'done'
                        this.tags[index].color = 'analogoD'
                    }
                    if (info.etilismo) {
                        var index = this.buscarTag('etilismo')
                        this.tags[index].icon = 'done'
                        this.tags[index].color = 'analogoD'
                    }
                    if (info.tabagismo) {
                        var index = this.buscarTag('tabagismo')
                        this.tags[index].icon = 'done'
                        this.tags[index].color = 'analogoD'
                    }
                    if (info.usaOculus) {
                        var index = this.buscarTag('usaOculus')
                        this.tags[index].icon = 'done'
                        this.tags[index].color = 'analogoD'
                    }
                    if (info.usoMedicamento) {
                        var index = this.buscarTag('usoMedicamento')
                        this.tags[index].icon = 'done'
                        this.tags[index].color = 'analogoD'
                    }
                    if (info.alergia) {
                        var index = this.buscarTag('alergia')
                        this.tags[index].icon = 'done'
                        this.tags[index].color = 'analogoD'
                    }
                    if (info.antecedentesFamiliares) {
                        var index = this.buscarTag('antecedentesFamiliares')
                        this.tags[index].icon = 'done'
                        this.tags[index].color = 'analogoD'
                    }
                    if (info.antecedentesPatologicos) {
                        var index = this.buscarTag('antecedentesPatologicos')
                        this.tags[index].icon = 'done'
                        this.tags[index].color = 'analogoD'
                    }
                }
            })
        },
        buscarTag(nome) {
            for (let i = 0; i < this.tags.length; i++) {
                const e = this.tags[i];
                if (e.nome == nome) return i
            }
        },
        encerrarAtendimento_() {

            //this.$emit('encerrarAtd') [{conteudoProntuario: '', }]
            if (this.conteudoProntuario && this.conteudoProntuario != '<p></p>') {
                if (this.dadosProntuario.length > 0) {
                    let index = null
                    this.dadosProntuario.forEach((d, i) => {
                        console.log(this.mFicha.idAtendimento == d.idAtendimento);
                        if (this.mFicha.idAtendimento == d.idAtendimento) {
                            index = i
                        }
                    })
                    if (index != null) {
                        if (this.dadosProntuario[index].solicitacoes != null &&
                            this.dadosProntuario[index].solicitacoes.length > 0) {
                            // console.log(this.dadosProntuario[index].solicitacoes);
                            this.desejaEncerrar = true
                            // this.$emit('encerrarAtd')
                        } else if (this.dadosProntuario[index].solicitacoesLaboratorio != null &&
                            this.dadosProntuario[index].solicitacoesLaboratorio.length > 0) {
                            this.desejaEncerrar = true
                            // this.$emit('encerrarAtd')
                        } else {
                            this.dialog = true
                        }
                    }
                    // console.log('-----=' ,this.dadosProntuario[ind
                }
            } else {
                this.erroProntuarioVazio = true;
            }

        },
        verificarExamesComStatusAberto() {
            this.dialogLaudo = false
            this.dialogProntuario = false
            this.dialogLaudo = this.consultasPaciente.some(
                consulta => consulta.exigeLaudoClinico === 1 && consulta.status === 'A'
            )
            var isProntuario = this.consultasPaciente.some(
                consulta => consulta.exigeProntuario === 1
            )
            console.log(isProntuario, this.conteudoProntuario, this.conteudoProntuario)
            if (isProntuario) {
                if (this.conteudoProntuario == '' || this.conteudoProntuario == '<p></p>') {
                    this.dialogProntuario = true
                }
            } else {
                this.dadosProntuario[0].idAtendimento = this.mFicha.idAtendimento
            }

            if (!this.dialogLaudo && !this.dialogProntuario) {
                this.encerrarAtendimento()
            }
        },
        /* encerrarAtendimento() {
            this.dialogLaudo = false
            this.dialogProntuario = false
            let index = null;

            this.dadosProntuario.forEach((d, i) => {
                if (this.mFicha.idAtendimento === d.idAtendimento) {
                    index = i;
                }
            });

            if (index !== null) {

                const solicitacoes = this.dadosProntuario[index].solicitacoes;
                const solicitacoesLaboratorio = this.dadosProntuario[index].solicitacoesLaboratorio;

                if ((solicitacoes != null && solicitacoes.length > 0) ||
                    (solicitacoesLaboratorio != null && solicitacoesLaboratorio.length > 0)) {
                    // Habilita o diálogo para confirmação de encerramento
                    this.desejaEncerrar = true;
                } else {
                    this.dialog = true;
                }
            }

        },*/
        
        verificarCondicoesEncerramento() {
            // Verifica cada consulta do paciente
            for (const consulta of this.consultasPaciente) {
                // Verificação do laudo clínico
                if (consulta.idMedico == this.user.id) {
                console.log('Exige Laudo Clínico:', consulta.exigeLaudoClinico, consulta.laudo);
                
                if ((consulta.exigeLaudoClinico == 1 && consulta.exigeFichaAso == 0 && consulta.psicoSocial == 0) && (consulta.laudo == null || consulta.laudo == '' )) {
                    this.mostrarAlerta('Laudo clínico obrigatório não preenchido');
                    return false;
                }

                // Verificação da ficha ASO
                
                  if (consulta.exigeFichaAso == 1) {
                console.log('Exige Ficha ASO:', consulta.statusFormulario, consulta.statusFormulario.fichaExame);
                    if (!consulta.statusFormulario || consulta.statusFormulario.existeAlgumFormulario !== true) {
                        this.mostrarAlerta('Ficha ASO obrigatória não preenchida.');
                        return false;
                    }
                }
                // Verificação da avaliação psicossocial
                if (consulta.psicoSocial == 1) {
                    if (!consulta.statusFormulario || consulta.statusFormulario.existeAlgumFormulario !== true) {
                        this.mostrarAlerta('Avaliação psicossocial obrigatória não preenchida.');
                        return false;
                    }
                    }
            }
            }
            
            // Todas as condições foram atendidas
            return true;
        },

        mostrarAlerta(mensagem) {
            this.dialogAlerta = true;
            this.mensagemAlerta = mensagem;
        },

            // Modifique sua função encerrarAtendimento para usar a verificação
            encerrarAtendimento() {
                this.dialogLaudo = false;
                this.dialogProntuario = false;
                
                // Primeiro verifica todas as condições obrigatórias
                if (!this.verificarCondicoesEncerramento()) {
                    return; // Interrompe se houver pendências
                }

                // Continua com a lógica original de verificação de solicitações
                let index = null;
                this.dadosProntuario.forEach((d, i) => {
                    if (this.mFicha.idAtendimento === d.idAtendimento) {
                        index = i;
                    }
                });

                if (index !== null) {
                    const solicitacoes = this.dadosProntuario[index].solicitacoes;
                    const solicitacoesLaboratorio = this.dadosProntuario[index].solicitacoesLaboratorio;

                    if ((solicitacoes != null && solicitacoes.length > 0) ||
                        (solicitacoesLaboratorio != null && solicitacoesLaboratorio.length > 0)) {
                        this.desejaEncerrar = true;
                    } else {
                        this.dialog = true;
                    }
                }
            },
        encerrarVoucher(armazenar) {
            if (this.user.voucher == 'POSAUTOMATICO') {
                let index = null;

                // Encontra o índice correspondente ao idAtendimento
                this.dadosProntuario.forEach((d, i) => {
                    if (this.mFicha.idAtendimento === d.idAtendimento) {
                        index = i;
                    }
                });

                if (index == 0 || index !== null) {
                    const prontuario = this.dadosProntuario[index];

                    // Extrai os ids de solicitacoes
                    const solicitacoes = Array.isArray(prontuario.solicitacoes)
                        ? prontuario.solicitacoes.flatMap(solicitacao =>
                            solicitacao.items.map(item => ({ id: item.idExame }))
                        )
                        : [];

                    // Extrai os ids de solicitacoesLaboratorio
                    const solicitacoesLaboratorio = Array.isArray(prontuario.solicitacoesLaboratorio)
                        ? prontuario.solicitacoesLaboratorio.flatMap(solicitacao =>
                            solicitacao.items.map(item => ({ id: item.idExame }))
                        )
                        : [];


                    // Gera o voucher para CLINICA se solicitacoes não estiver vazio
                    console.log('solicitacoesClinicas Voucher: ', solicitacoes);

                    if (solicitacoes.length > 0) {
                        console.log('solicitacoesClinicas Passou: ', solicitacoes);
                        this.gerarVoucher('CLINICA', solicitacoes, armazenar, '');
                    }

                    // Gera o voucher para LABORATORIO se solicitacoesLaboratorio não estiver vazio
                    console.log('solicitacoesLaboratorio Voucher: ', solicitacoesLaboratorio);
                    if (solicitacoesLaboratorio.length > 0) {
                        console.log('solicitacoesLaboratorio Passou: ', solicitacoesLaboratorio);
                        this.gerarVoucher('LABORATORIO', solicitacoesLaboratorio, armazenar, '');
                    }
                }
            }
        },
        confirmarEncerramento() {
            // this.$emit('dadosProntuario', this.dadosProntuario)
            this.$emit('encerrarAtd')

            // Reseta o estado do diálogo
            this.desejaEncerrar = false;


            // Dispara o evento de encerramento
        },

        gerarVoucher(tipoSolicitacao, exames, armazenar = true, observacao = "") {
            
            posAtendimentoService.gerarVoucher({
                exames: exames, // A variável exames deve ser definida de forma apropriada
                idEmpresa: this.user.idEmpresa,
                idUnidadeNegocio: this.user.idUnidade,
                tipoSolicitacao: tipoSolicitacao, // Define o tipo de solicitação aqui
                idPaciente: this.mFicha.idPaciente,
                idPrestadorSolicitante: this.user.idPrestador, // id do médico
                idUsuario: this.user.id,
                armazenar: armazenar,
                obs: observacao
            }).then(r => {
                console.log(r.data);
            })
        },

        retornarProntuariosPaciente(offset) {
            this.loadProntuarios = true
            medicoService.medico.retornarProntuariosPaciente(this.mFicha.idPaciente, 1, offset, this.isMedico == false ? '-' : this.user.id, this.dataSaida, this.especialidade).then(r => {
                if (r.status == 200) {
                    console.log('prontuario: ', r.data)

                    const data = new Date(r.data.dataSaida);

                    const dia = String(data.getDate()).padStart(2, "0");
                    const mes = String(data.getMonth() + 1).padStart(2, "0");
                    const ano = data.getFullYear();

                    const dataFormatada = `${dia}/${mes}/${ano}`;
                    console.log(dataFormatada);
                    r.data.dataSaida = dataFormatada
                    this.prontuarios.push(r.data)

                }
            }).finally(() => {
                this.loadProntuarios = false
            })

        },
        retornarEspecialidades() {
            medicoService.medico.retornarEspecialidades().then(r => {
                if (r.status == 200) {
                    this.especialidades = r.data
                }
            })
        },
        listarProntuariosSimples() {
            this.loadListaProntuario = true
            // medicoService.medico.listarProntuariosSimples(this.mFicha.idOrdemServico, this.isMeusProntuarios === true ? this.user.id : null).then(r => {
            medicoService.medico.listarProntuariosSimples(this.mFicha.idOrdemServico, this.isMeusProntuarios == true ? this.user.idPrestador : null).then(r => {
                if (r.status == 200) {
                    this.listaProntuariosv2 = r.data
                    this.listaPv2 = r.data
                }
            }).finally(() => {
                this.loadListaProntuario = false
            })
        },
        listarLaudosSimples() {
            this.loadListaProntuario = true
            medicoService.medico.listarLaudosSimples(this.mFicha.idOrdemServico, this.isMeusProntuarios == true ? this.user.idPrestador : null).then(r => {
                if (r.status == 200) {
                    this.listaLaudosV2 = r.data
                    this.listaL = r.data
                }
            }).finally(() => {
                this.loadListaProntuario = false
            })
        },
        retornarProntuarioPorId(idProntuario) {
            medicoService.medico.retornarProntuarioPorId(idProntuario).then(r => {
                //  console.log('prontuario: ', r.data)

                /* const data = new Date(r.data.dataSaida)

                const dia = String(data.getDate()).padStart(2, "0")
                const mes = String(data.getMonth() + 1).padStart(2, "0")
                const ano = data.getFullYear()

                const dataFormatada = `${dia}/${mes}/${ano}`
                console.log(dataFormatada) */
                r.data.dataSaida = r.data.prontuario.data
                this.prontuarios = [r.data]
                this.isAddProntuario = false
            })
        },
        consultarInfoExames(consultasPaciente) {
            // Reseta os contadores antes de começar a processar
            this.isProntuario = false
            const idsExames = consultasPaciente.map(consulta => consulta.idExame)
            this.exigeAludo = 0
            medicoService.medico.retornarExamesPorId(idsExames).then(r => {
                if (r.status == 200) {
                    const exames = r.data;
                    
                    consultasPaciente.forEach(consulta => {
                        const exameEncontrado = exames.find(exame => exame.idExame == consulta.idExame);

                        if (exameEncontrado) {
                            // Incrementa exigeAludo se exigeLaudoClinico for true
                            if (exameEncontrado.exigeLaudoClinico) {
                                this.exigeAludo += 1;
                                this.items.forEach(item => {
                                    if (item.id == 7) item.badge = this.exigeAludo
                                })
                            }

                            // Muda exigeProntuario para true se qualquer exame exigir prontuário
                            if (exameEncontrado.exigeProntuario) {
                                this.exigeProntuario = true
                                this.items.forEach(item => {
                                    if (item.id == 2) item.badge = 1
                                })
                            }

                            // Adiciona os dados encontrados à consulta, se necessário
                            if (exameEncontrado.exigeProntuario == 1) {
                                this.isProntuario = true
                            }
                            consulta.exigeLaudoClinico = exameEncontrado.exigeLaudoClinico
                            consulta.exigeProntuario = exameEncontrado.exigeProntuario
                            consulta.exigeFichaAso = exameEncontrado.exigeFichaAso
                            consulta.psicoSocial = exameEncontrado.psicoSocial
                            consulta.tipoAPI = exameEncontrado.tipoAPI;
                            consulta.laudo = ''
                            consulta.status = ''
                            if (consulta.idexamesos != null) {
                                medicoService.medico.buscarLaudoComStatus(consulta.idexamesos).then(r => {
                                    if (r.status === 200) {
                                        if (r.data.laudoClinico != null) {
                                            consulta.laudo = r.data.laudoClinico.descricaoLaudo
                                            consulta.statusLaudo = r.data.laudoClinico.status
                                        }
                                        consulta.statusFormulario = r.data.statusFormulario;
                                    }
                                })
                            }
                        }
                    })
                    // Ordenar as consultas conforme a condição
                    consultasPaciente.sort((a, b) => {
                        const aCumpreCondicao = a.exigeLaudoClinico && a.cor !== 'grey lighten-1';
                        const bCumpreCondicao = b.exigeLaudoClinico && b.cor !== 'grey lighten-1';

                        if (aCumpreCondicao && !bCumpreCondicao) return -1;
                        if (!aCumpreCondicao && bCumpreCondicao) return 1;
                        return 0;
                    })
                }
            }).catch(error => {
                console.error('Erro ao buscar exames:', error);
            });
        }
    },
    watch: {
        prontuarioSelecionado(val) {
            if (this.prontuarioSelecionado != null) {
                this.retornarProntuarioPorId(this.listaPv2[val].idProntuario)
            }
        },
        laudoSelecionado(val) {
            if (this.laudoSelecionado != null) {
                // this.retornarLaudoClinicoPorId(this.listaPv2[val].idLaudoClinico)
            }
        },
        solicitacoesCards(val) {
            // console.log(val, '-----');
            if (this.dadosProntuario.length > 0) {
                let index = null
                this.dadosProntuario.forEach((d, i) => {
                    if (this.mFicha.idAtendimento == d.idAtendimento) {
                        //console.log(d, i)
                        index = i
                    }
                })
                if (index != null) {
                    this.dadosProntuario[index].idAtendimento = this.mFicha.idAtendimento
                    this.dadosProntuario[index].solicitacoes = val
                    this.$store.dispatch('updateProntuario', this.dadosProntuario)
                }
            } else {
                console.log('3')
                this.dadosProntuario.push({
                    idAtendimento: this.mFicha.idAtendimento,
                    solicitacoes: val
                })
                this.$store.dispatch('updateProntuario', this.dadosProntuario)
            }
        },

        solicitacoesLaboratorioCards(val) {
            console.log(val, '-----', val, this.dadosProntuario);
            if (this.dadosProntuario.length > 0) {
                let index = null
                this.dadosProntuario.forEach((d, i) => {
                    if (this.mFicha.idAtendimento == d.idAtendimento) {
                        //console.log(d, i)
                        index = i
                    }
                })
                if (index != null) {
                    this.dadosProntuario[index].idAtendimento = this.mFicha.idAtendimento
                    this.dadosProntuario[index].solicitacoesLaboratorio = val
                    console.log('Storage -----=', this.dadosProntuario[index]);
                    this.$store.dispatch('updateProntuario', this.dadosProntuario)
                }
            } else {
                console.log('3')
                this.dadosProntuario.push({
                    idAtendimento: this.mFicha.idAtendimento,
                    solicitacoesLaboratorio: val
                })
                this.$store.dispatch('updateProntuario', this.dadosProntuario)
            }
        },
        receitas(data) {
            //console.log('--------------', data)
            if (this.dadosProntuario.length > 0) {
                let index = null
                this.dadosProntuario.forEach((d, i) => {
                    if (this.paciente.idAtendimento == d.idAtendimento) {
                        index = i
                        return
                    }
                })
                if (index != null) {
                    this.dadosProntuario[index].idAtendimento = this.paciente.idAtendimento
                    this.dadosProntuario[index].receitas = this.receitas
                    this.$store.dispatch('updateProntuario', this.dadosProntuario)

                }
            } else {
                // console.log('3')
                this.dadosProntuario.push({
                    idAtendimento: this.paciente.idAtendimento,
                    receitas: this.receitas
                })
                this.$store.dispatch('updateProntuario', this.dadosProntuario)
            }
        },
        conteudoProntuario(data) {
            // console.log('----------->?', data);
            //console.log(data, this.dadosProntuario, this.dadosProntuario.length);

            if (this.dadosProntuario.length > 0) {

                let index = null
                this.dadosProntuario.forEach((d, i) => {
                    console.log(this.mFicha.idAtendimento, d.idAtendimento);
                    if (this.mFicha.idAtendimento == d.idAtendimento) {
                        index = i
                    }
                })
                //console.log('indexxxxxxxxxxxxxxxxx: ', index);
                if (index != null) {
                    this.dadosProntuario[index].idAtendimento = this.mFicha.idAtendimento
                    this.dadosProntuario[index].conteudoProntuario = data
                    //console.log('-----1');
                    this.$store.dispatch('updateProntuario', this.dadosProntuario)
                    this.$emit('conteudoProntuario', data)
                } else {
                    this.dadosProntuario[0].idAtendimento = this.mFicha.idAtendimento
                    this.dadosProntuario[0].conteudoProntuario = data
                    //console.log('-----2');
                    this.$store.dispatch('updateProntuario', this.dadosProntuario)
                    this.$emit('conteudoProntuario', data)
                }
            }
            //this.dadosProntuario.idAtendimento = this.mFicha.idAtendimento
            //this.dadosProntuario.conteudoProntuario = data
            //this.$store.dispatch('updateProntuario', this.dadosProntuario)

        },
        conteudoLaudo(data) {
            // this.$store.dispatch('updateProntuario', [])

            if (this.dadosProntuario.length > 0) {
                let index = null
                this.dadosProntuario.forEach((d, i) => {

                    if (this.mFicha.idAtendimento == d.idAtendimento) {
                        console.log(d, i)
                        index = i
                        return
                    }
                })
                if (index != null) {
                    // console.log('2')
                    this.dadosProntuario[index].idAtendimento = this.mFicha.idAtendimento
                    this.dadosProntuario[index].conteudoLaudo = data
                    this.$store.dispatch('updateProntuario', this.dadosProntuario)

                }
            } else {
                // console.log('3')
                this.dadosProntuario.push({
                    idAtendimento: this.mFicha.idAtendimento,
                    conteudoLaudo: data
                })
                this.$store.dispatch('updateProntuario', this.dadosProntuario)
            }
            // this.$emit('conteudoLaudo', data)
            // console.log(this.dadosProntuario.idAtendimento, this.dadosProntuario.conteudoLaudo);
            // this.dadosProntuario.idAtendimento = this.mFicha.idAtendimento

            // this.$store.dispatch('updateProntuario', this.dadosProntuario)
            // this.$emit('conteudoLaudo', data)
        },

        receitas(data) {
            // this.dadosProntuario.idAtendimento = this.mFicha.idAtendimento
            // this.dadosProntuario.receitas = data
            this.$store.dispatch('updateProntuario', this.dadosProntuario)

            if (this.dadosProntuario.length > 0) {
                let index = null
                this.dadosProntuario.forEach((d, i) => {

                    if (this.mFicha.idAtendimento == d.idAtendimento) {
                        index = i
                        return
                    }
                })
                if (index != null) {
                    console.log('2')
                    this.dadosProntuario[index].idAtendimento = this.mFicha.idAtendimento
                    this.dadosProntuario[index].receitas = this.receitas
                    this.$store.dispatch('updateProntuario', this.dadosProntuario)

                }
            } else {
                console.log('3')
                this.dadosProntuario.push({
                    idAtendimento: this.mFicha.idAtendimento,
                    receitas: this.receitas
                })
                this.$store.dispatch('updateProntuario', this.dadosProntuario)
            }

            //this.$emit('receitas', data)
        },
        mSolicitacoes(data) {
            // this.$store.dispatch('updateProntuario', [])

            if (this.dadosProntuario.length > 0) {
                let index = null
                this.dadosProntuario.forEach((d, i) => {

                    if (this.mFicha.idAtendimento == d.idAtendimento) {
                        console.log(d, i)
                        index = i
                        return
                    }
                })
                if (index != null) {
                    // console.log('2')
                    this.dadosProntuario[index].idAtendimento = this.mFicha.idAtendimento
                    this.dadosProntuario[index].solicitacoes = data
                    console.log('-----1');
                    this.$store.dispatch('updateProntuario', this.dadosProntuario)

                }
            } else {
                // console.log('3')
                console.log('-----2');
                this.dadosProntuario.push({
                    //idAtendimento: this.mFicha.idAtendimento,
                    solicitacoes: data
                })
                this.$store.dispatch('updateProntuario', this.dadosProntuario)
            }
            //this.$emit('soli', data)
            // console.log(this.dadosProntuario.idAtendimento, this.dadosProntuario.conteudoLaudo);
            // this.dadosProntuario.idAtendimento = this.mFicha.idAtendimento

            // this.$store.dispatch('updateProntuario', this.dadosProntuario)
            // this.$emit('conteudoLaudo', data)
        },

        mItem(data) {
            if (data != null) {
                this.selectedItem = data
                EventBus.$emit('item-selecionado', data)
            } else {
                this.mItem = this.selectedItem
            }
            if (this.selectedItem != 1) {
                this.dialogResumo = false
            }
        },
        isMedico() {
            this.prontuarios = []
            this.qtdProntuarios = 0
            this.currentProntuario = 0
            // this.buscarQtdProntuariosPaciente()
        },
        especialidade() {
            this.prontuarios = []
            this.qtdProntuarios = 0
            this.currentProntuario = 0
            // this.buscarQtdProntuariosPaciente()
        },
        searchProntuariov2(val) {
            if (val !== '') {
                let lista = this.listaProntuariosv2.filter(s =>
                    Object.values(s).some(campo =>
                        campo && campo.toString().toLowerCase().includes(val.toLowerCase())
                    )
                );
                console.log(lista);
                this.listaPv2 = lista;
            } else {
                console.log('---');
                this.listaPv2 = this.listaProntuariosv2;
            }
        },
        searchLaudo(val) {
            if (val !== '') {
                let lista = this.listaLaudosv2.filter(s =>
                    Object.values(s).some(campo =>
                        campo && campo.toString().toLowerCase().includes(val.toLowerCase())
                    )
                );
                // console.log(lista);
                this.listaL = lista;
            } else {
                // console.log('---');
                this.listaL = this.listaProntuariosv2;
            }
        },
        selectedItem(val) {
            this.showPdfViewer = false
            if (val == 5) {
                this.buscarRelatoriosAtendimento()
            }
            console.log('----', val)
            if (val == 2) {
                this.listarReceitasMedicas()
            }
            if (val == 0) {
                this.isShow = false
                if (this.resumoProntuarios != '') {
                    this.retornarResumoProntuario()
                }
            }
        },

    },
    computed: {
        gruposFiltrados() {
            const agrupado = {};

            this.listaConsultas.forEach(item => {
                const data = item.data ? item.data.split(" ")[0] : "Sem data";

                // ✅ Inicializa agrupamento
                if (!agrupado[data]) {
                agrupado[data] = [];
                }

                // ✅ Aplica filtro por tipo
                if (this.filtros.length && !this.filtros.includes(item.tipo)) return;

                // ✅ Aplica filtro por "Meus atendimentos"
                if (this.isMeusAtendimentos && item.idmedico !== this.user.id) return;

                // ✅ Aplica busca no conteúdo (HTML ou texto)
                if (this.buscaConteudo.trim()) {
                const textoPlano = item.conteudo.replace(/<[^>]*>/g, "").toLowerCase();
                if (!textoPlano.includes(this.buscaConteudo.toLowerCase())) return;
                }

                agrupado[data].push(item);
            });

            // ✅ Filtra datas que têm pelo menos 1 item
            const datasValidas = Object.keys(agrupado).filter(
                data => agrupado[data].length > 0
            );

            // ✅ Ordena e retorna apenas grupos com conteúdo
            return datasValidas
                .sort(
                (a, b) =>
                    new Date(b.split("/").reverse().join("/")) -
                    new Date(a.split("/").reverse().join("/"))
                )
                .map(data => ({ data, itens: agrupado[data] }));
            }

},
        
    mounted() {

        EventBus.$on('encerrarVoucher', (data) => {
            this.encerrarVoucher(false)
        })
        // this.$store.dispatch('updateProntuario', [])
        this.dadosProntuario = this.$store.getters.prontuario
        // console.log('storage --------', this.dadosProntuario)
        if (this.dadosProntuario.length > 0) {
            for (let i = 0; i < this.dadosProntuario.length; i++) {
                const d = this.dadosProntuario[i];
                // console.log('--------------', d);

                if (this.mFicha.idAtendimento == d.idAtendimento) {

                    this.conteudoLaudo = d.conteudoLaudo
                    this.conteudoProntuario = d.conteudoProntuario

                    if (d.solicitacoes != null && d.solicitacoes != '') {
                        //console.log(d.solicitacoes, '---------=----------');
                        this.solicitacoesCards = d.solicitacoes
                    }
                    if (d.solicitacoesLaboratorio != null && d.solicitacoesLaboratorio != '') {
                        //console.log(d.solicitacoes, '---------=----------');
                        this.solicitacoesLaboratorioCards = d.solicitacoesLaboratorio
                    }
                    if (d.receitas != null) {
                        this.receitas = d.receitas
                    }
                    break
                }
            }
        }

        this.user = this.$store.getters.usuario
        if (this.infoPaciente == '') {
            this.carregarInfomacoesPaciente();
        }

        // this.buscarQtdProntuariosPaciente()
        this.retornarEspecialidades()
        this.retornarInformacoesPacienteOs()
        this.listarProntuariosSimples()
        this.listarLaudosSimples()
        this.retornarResumoProntuario()

        if (this.mFicha.idProntuario != null && this.mFicha.idProntuario != '') {
            this.isAddProntuario = false
            this.isMeu = true
        }
        this.socket = io.connect(socketService.SOCKET_URL, {
            query: {
                token: getToken()
            }
        })

        this.chamarSocket()

        // console.log('procedimento --> ', this.consultasPaciente)
        this.consultarInfoExames(this.consultasPaciente)
        this.buscarProntuarioPorIdExamesOS()
        this.retornarListaConsultas()
        // console.log('receitas: ', this.receitas)
    },
    destroyed() {

    }
}
</script>

<style scoped>
ol {
    counter-reset: li;
    /* Initiate a counter */
    list-style: none;
    /* Remove default numbering */
    *list-style: decimal;
    /* Keep using default numbering for IE6/7 */
    font: 15px 'trebuchet MS', 'lucida sans';
    padding: 0;
    margin-bottom: 4em;
    text-shadow: 0 1px 0 rgba(255, 255, 255, .5);
}

ol ol {
    margin: 0 0 0 2em;
    /* Add some left margin for inner lists */
}

.rounded-list a {
    position: relative;
    display: block;
    padding: .4em .4em .4em 2em;
    *padding: .4em;
    margin: .5em 0;
    background: #ECEFF1;
    color: #424242;
    text-decoration: none;
    border-radius: .3em;
    transition: all .3s ease-out;
}

.rounded-list a:hover {
    background: #eee;
}

.rounded-list a:hover:before {
    transform: rotate(360deg);
}

.rounded-list a:before {
    content: counter(li);
    counter-increment: li;
    position: absolute;
    left: -1.3em;
    top: 50%;
    margin-top: -1.3em;
    background: #00BCD4;
    height: 2em;
    width: 2em;
    line-height: 2em;
    border: .3em solid #fff;
    text-align: center;
    font-weight: bold;
    border-radius: 2em;
    transition: all .4s ease-out;
}

.rounded-exame a {
    position: relative;
    display: block;
    padding: .4em .4em .4em 2em;
    margin: .5em 0;
    background: #DAF5D5;
    /* Background de alerta */
    color: #050402;
    /* Texto de alerta */
    text-decoration: none;
    border-radius: .3em;
    transition: all .3s ease-out;
}

.rounded-exame a:hover {
    background: #32CD32;
    /* Cor de hover mais escura */
}

.rounded-exame a:hover:before {
    transform: rotate(360deg);
}

.rounded-exame a:before {
    content: "!";
    position: absolute;
    left: -1.3em;
    top: 50%;
    margin-top: -1.3em;
    background: #32CD32;
    /* Cor de fundo do ícone */
    height: 2em;
    width: 2em;
    line-height: 2em;
    border: .3em solid #fff;
    text-align: center;
    font-weight: bold;
    border-radius: 2em;
    color: #fff;
    transition: all .4s ease-out;
}


.prontuario-card {
    background-color: #f8f7f7;
    /* cor da prancheta */
    border: 2px solid #ccc;
    /* cor da borda */
    border-radius: 8px;
    /* arredondar bordas */
    padding: 16px;
}

.selected-prontuario {
    background-color: #f8f7f7;
    /* cor da prancheta */
    border: 2px solid #FEAC63;
    /* cor da borda */
    border-radius: 8px;
    /* arredondar bordas */
    padding: 16px;
}

.selected-medicamento {
    background-color: #f8f7f7;
    /* cor da prancheta */
    border: 2px solid #FEAC63;
    /* cor da borda */
    border-radius: 8px;
    /* arredondar bordas */
    padding: 16px;
}

.selected-exames {
    background-color: #f8f7f7;
    /* cor da prancheta */
    border: 2px solid #FEAC63;
    /* cor da borda */
    border-radius: 8px;
    /* arredondar bordas */
    padding: 16px;
}

.prontuario-footer {
    border-top: 2px solid #dddcdc;
    /* borda no rodapé */
    padding-top: 8px;
    margin-top: 8px;
    text-align: right;
    font-size: 14px;
}

.footer-text {
    font-size: 14px;
    /* aumentar tamanho da fonte do rodapé */
}
</style>
